import ne from "@arcgis/core/layers/FeatureLayer";
import S from "@arcgis/core/Graphic";
import dr from "dompurify";
import Te from "@arcgis/core/geometry/Polygon";
import qe from "@arcgis/core/geometry/SpatialReference";
import A from "@arcgis/core/request";
import { createLogger as Ge } from "@origo/logger";
import * as ar from "@arcgis/core/geometry/operators/areaOperator";
import * as ir from "@arcgis/core/geometry/operators/intersectionOperator";
import * as lr from "@arcgis/core/geometry/operators/intersectsOperator";
import { queryOptions as q, useQuery as C, useQueryClient as b, useMutation as v } from "@tanstack/react-query";
import { z as j } from "zod";
import { jsx as ur } from "react/jsx-runtime";
import { createContext as mr, useMemo as cr, useContext as ke } from "react";
class R extends Error {
  constructor(r, t) {
    super(r), this.name = this.constructor.name, this.cause = t;
  }
}
class oe extends R {
  constructor(r) {
    super(`Fant ikke seksjon med GlobalID=${r}`), this.globalId = r, this.code = "SECTION_NOT_FOUND";
  }
}
class Ce extends R {
  constructor(r) {
    super(`Fant ikke område med id=${r}`), this.områdeId = r, this.code = "OMRÅDE_NOT_FOUND";
  }
}
class pr extends R {
  constructor() {
    super(...arguments), this.code = "OVERRIDE_CONFLICT";
  }
}
class fr extends R {
  constructor(r) {
    super(`Sirkulær referanse oppdaget i område-hierarki for id=${r}`), this.områdeId = r, this.code = "OMRÅDE_CYCLE";
  }
}
class G extends R {
  constructor(r, t = {}) {
    super(r), this.fieldErrors = t, this.code = "VALIDATION";
  }
}
class K extends R {
  constructor() {
    super(...arguments), this.code = "CONFIGURATION";
  }
}
class k extends R {
  constructor() {
    super(...arguments), this.code = "NETWORK";
  }
}
class yr extends R {
  constructor(r = "Mangler eller utløpt autentisering", t) {
    super(r, t), this.code = "AUTH";
  }
}
class T extends R {
  constructor() {
    super("Operasjonen ble avbrutt"), this.code = "ABORTED";
  }
}
function J(e, r) {
  if (r.has(e))
    return !0;
  for (const t of r)
    if (/^\d+$/.test(t) && e.startsWith(t + " -"))
      return !0;
  return !1;
}
function W(e) {
  const r = Array.isArray(e) ? e : e ? [e] : [];
  return new Set(
    r.filter((t) => typeof t == "string").map((t) => t.trim()).filter(Boolean)
  );
}
function P(e) {
  return e.seksjonstype === "Kommune" || e.kommunal;
}
function we(e, r, t, n) {
  if (r.type === "Kommune")
    return P(e);
  if (e.seksjonstype !== r.type)
    return !1;
  switch (r.type) {
    case "Plan":
      return !0;
    case "Delområdetype":
      return !!e.delområdetype && J(e.delområdetype, n);
    case "Delområdegruppe":
    case "Delområde":
    case "Område":
      return !!e.områdeId && t.has(e.områdeId);
  }
}
function Ke(e, r, t, n = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set()) {
  switch (r.type) {
    case "Kommune":
      return !1;
    case "Plan":
      return P(e);
    case "Delområdetype":
      return P(e) || e.seksjonstype === "Plan";
    case "Delområdegruppe":
      return P(e) || e.seksjonstype === "Plan" || e.seksjonstype === "Delområdetype" && !!e.delområdetype && J(e.delområdetype, t);
    case "Delområde":
      return P(e) || e.seksjonstype === "Plan" || e.seksjonstype === "Delområdetype" && !!e.delområdetype && J(e.delområdetype, t) || e.seksjonstype === "Delområdegruppe" && !!e.områdeId && o.has(e.områdeId);
    case "Område":
      return P(e) || e.seksjonstype === "Plan" || e.seksjonstype === "Område" || e.seksjonstype === "Delområdetype" && !!e.delområdetype && J(e.delområdetype, t) || e.seksjonstype === "Delområdegruppe" && !!e.områdeId && o.has(e.områdeId) || e.seksjonstype === "Delområde" && !!e.områdeId && n.has(e.områdeId);
  }
}
function Ir(e, r, t, n) {
  return !we(
    e,
    r,
    t,
    n
  );
}
function Be(e, r) {
  return r || !!e.parentGlobalId;
}
function gr(e) {
  return !e;
}
function Me(e, r) {
  return e === "Kommune" || !r;
}
function ye(e) {
  return P(e) ? e.topp === !1 ? "bottom" : "top" : "middle";
}
const Oe = { top: 0, middle: 1, bottom: 2 };
function _e(e, r, t) {
  const n = Oe[ye(e)] - Oe[ye(r)];
  if (n !== 0)
    return n;
  if (t) {
    const o = t(e.planId) - t(r.planId);
    if (o !== 0)
      return o;
  }
  return (e.prioritet ?? 0) - (r.prioritet ?? 0);
}
function te(e) {
  return !!e.parentGlobalId && !e.overstyrer && !e.synlig;
}
function je(e) {
  const r = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Map();
  for (const o of e)
    o.globalId && t.set(o.globalId, o);
  const n = (o, s) => {
    if (s.has(o))
      return [];
    s.add(o);
    const d = t.get(o);
    return d?.parentGlobalId ? [d.parentGlobalId, ...n(d.parentGlobalId, s)] : [];
  };
  for (const o of e)
    if (o.overstyrer && o.globalId) {
      const s = n(o.globalId, /* @__PURE__ */ new Set());
      for (const d of s)
        r.add(d);
    }
  return r;
}
function Ue(e, r) {
  return e.filter((t) => !(t.globalId && r.has(t.globalId) || t.parentGlobalId && !t.overstyrer && !te(t)));
}
function Le(e, r, t = {}) {
  const n = W(t.områdeIdCandidates), o = W(t.delområdetypeCandidates), s = W(t.ancestorDelområdeIds), d = W(t.ancestorGruppeIds), i = (m) => we(m, r, n, o), l = (m) => Ke(
    m,
    r,
    o,
    s,
    d
  ), a = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Set();
  for (const m of e)
    !m.parentGlobalId || !te(m) || (i(m) ? a.set(m.parentGlobalId, m.objectId) : l(m) && u.add(m.parentGlobalId));
  return e.filter((m) => !te(m)).map((m) => {
    const c = !i(m), p = !!(m.globalId && u.has(m.globalId)), f = m.globalId ? a.get(m.globalId) : void 0, g = !!m.parentGlobalId && m.overstyrer && i(m);
    return {
      ...m,
      isInherited: c,
      inheritedFrom: c ? m.seksjonstype : void 0,
      canToggleOverride: Be(m, c),
      canEdit: !c,
      canHide: p ? !1 : Me(m.seksjonstype, c),
      isHiddenAtThisLevel: f != null,
      isHiddenByAncestor: p,
      isOverriddenAtThisLevel: g,
      overrideObjectId: g ? m.objectId : void 0,
      hideObjectId: f
    };
  });
}
function Qe(e) {
  const r = [];
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    n.prioritet !== t && r.push({ objectId: n.objectId, prioritet: t });
  }
  return r;
}
function hr(e) {
  return e.length;
}
function H(e, r, t, n, o = 10) {
  const s = /* @__PURE__ */ new Map();
  for (const p of t)
    s.set(p.id, p);
  const d = We(n), i = Je(t), l = [], a = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), m = /* @__PURE__ */ new Set();
  let c = s.get(e);
  for (let p = 0; p < o && c && !(!c.parentType || !c.parentId); p++) {
    if (c.parentType === "Område") {
      l.push(c.parentId), c = s.get(c.parentId);
      continue;
    }
    if (c.parentType === "Delområdetype")
      a.add(c.parentId);
    else if (c.parentType === "Delområde") {
      u.add(c.parentId);
      const f = d.get(c.parentId);
      f?.delområdetype && a.add(f.delområdetype);
      const g = i.get(c.parentId);
      g && m.add(g);
    }
    break;
  }
  return {
    planId: r,
    delområdetyper: Array.from(a),
    delområdeIds: Array.from(u),
    ancestorOmrådeIds: l,
    gruppeIds: Array.from(m)
  };
}
function be(e, r, t, n) {
  const o = Je(t), s = We(n).get(e), d = /* @__PURE__ */ new Set();
  s?.delområdetype && d.add(s.delområdetype);
  const i = /* @__PURE__ */ new Set(), l = o.get(e);
  return l && i.add(l), {
    planId: r,
    delområdetyper: Array.from(d),
    delområdeIds: [],
    ancestorOmrådeIds: [],
    gruppeIds: Array.from(i)
  };
}
function We(e) {
  const r = /* @__PURE__ */ new Map();
  for (const t of e)
    for (const n of t.children ?? [])
      r.set(n.id, n);
  return r;
}
function Je(e) {
  const r = /* @__PURE__ */ new Map();
  for (const t of e) {
    if (t.kind !== "delomradegruppe-member" || !t.parentId || t.parentType !== "Område")
      continue;
    const n = t.code ?? t.navn;
    n && r.set(n, t.parentId);
  }
  return r;
}
function ze(e, r) {
  if (r.length === 0 || e.gruppeIds.length === 0)
    return e;
  const t = new Set(r);
  return {
    ...e,
    gruppeIds: e.gruppeIds.filter((n) => !t.has(n))
  };
}
function He(e, r) {
  const t = [];
  for (const s of e)
    for (const d of s)
      t.push(d);
  const n = je(t), o = /* @__PURE__ */ new Map();
  for (const s of e)
    for (const d of s)
      d.isHiddenAtThisLevel || d.isHiddenByAncestor || d.synlig && d.globalId && (n.has(d.globalId) || o.has(d.globalId) || o.set(d.globalId, d));
  return Array.from(o.values()).sort(
    (s, d) => _e(s, d, r)
  );
}
function Ve(e, r, t) {
  return e.filter((n) => {
    const o = n.matrikkelenhetId == null || r != null && n.matrikkelenhetId === r, s = n.adresseId == null || t != null && n.adresseId === t;
    return o && s;
  });
}
function Ie(e, r, t) {
  if (r.length === 0)
    return [...e];
  const n = (a) => `${a.omradetype}:${a.omradeId}`, o = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set();
  for (const a of r) {
    const u = n({ omradeId: a.omradeId, omradetype: a.omradetype });
    a.operation === "remove" ? (o.add(u), s.delete(u)) : a.operation === "add" && !o.has(u) && s.add(u);
  }
  const d = e.filter((a) => !o.has(n(t.getKey(a)))), i = new Set(d.map((a) => n(t.getKey(a))));
  if (s.size === 0 || !t.addables)
    return d;
  const l = [];
  for (const a of t.addables) {
    const u = n(t.getKey(a));
    s.has(u) && !i.has(u) && (l.push(a), i.add(u));
  }
  return [...d, ...l];
}
const kr = {
  perMatrikkelenhet: /* @__PURE__ */ new Map(),
  utenMatrikkelenhet: [],
  perAdresse: /* @__PURE__ */ new Map()
};
function Ze(e, r, t) {
  if (r.length === 0)
    return e;
  const n = t === "kun-tillagte" ? /* @__PURE__ */ new Set() : new Set(e);
  for (const o of r)
    o.teigId !== void 0 && o.adresseId == null && (o.operation === "add" ? n.add(o.teigId) : n.delete(o.teigId));
  return [...n];
}
function wr(e, r, t) {
  const n = (o) => {
    const s = r.perMatrikkelenhet.get(o.matrikkelenhetId);
    !s || s.length === 0 || (o.teigIds = [...Ze(o.teigIds ?? [], s, t)]);
  };
  n(e);
  for (const o of e.seksjoner ?? [])
    n(o);
}
function Xe(e) {
  const r = /* @__PURE__ */ new Map();
  for (const t of e) {
    const n = [t.omradeId, t.omradetype, t.teigId, t.matrikkelenhetId, t.adresseId].map((s) => String(s)).join("|"), o = r.get(n) ?? [];
    o.push(t), r.set(n, o);
  }
  return [...r.values()].filter(
    (t) => t.some((n) => n.operation === "add") && t.some((n) => n.operation === "remove")
  );
}
const Jt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortedError: T,
  AuthError: yr,
  ConfigurationError: K,
  NetworkError: k,
  OmrådeCycleError: fr,
  OmrådeNotFoundError: Ce,
  OverrideConflictError: pr,
  SeksjonError: R,
  SeksjonNotFoundError: oe,
  TOMT_DELTASETT: kr,
  ValidationError: G,
  anvendDeltaerPåEnhetstre: wr,
  anvendTeigDeltaer: Ze,
  applyPropertyOverrides: Ie,
  belongsToAncestorContext: Ke,
  belongsToCurrentContext: we,
  canEdit: gr,
  canHide: Me,
  canToggleOverride: Be,
  compareSeksjonOrder: _e,
  computeOverriddenGlobalIds: je,
  enrichSections: Le,
  filterOverridden: Ue,
  finnBruddrader: Xe,
  getSectionPosition: ye,
  isHiddenMetadataSection: te,
  isInherited: Ir,
  isKommunal: P,
  matchesDelområdetype: J,
  mergeUniqueByGlobalId: He,
  nextPriority: hr,
  normalizePriorities: Qe,
  resolveDelområdeAncestors: be,
  resolveOmrådeAncestors: H,
  scopeOverridesToMatrikkelenhet: Ve,
  stripRemovedGruppeIds: ze,
  toStringSet: W
}, Symbol.toStringTag, { value: "Module" })), jr = [
  "Kommune",
  "Plan",
  "Delområdetype",
  "Delområdegruppe",
  "Delområde",
  "Område"
];
function Se(e) {
  switch (e.type) {
    case "Kommune":
      return "Kommune";
    case "Plan":
      return `Plan:${e.planId}`;
    case "Delområdetype":
      return `Delområdetype:${e.planId}:${e.delområdetype}`;
    case "Delområdegruppe":
      return `Delområdegruppe:${e.planId}:${e.gruppeId}`;
    case "Delområde":
      return `Delområde:${e.planId}:${e.områdeId}:${e.delområdetype ?? ""}`;
    case "Område":
      return `Område:${e.planId}:${e.områdeId}`;
  }
}
const br = ["p", "br", "b", "strong", "i", "em", "u", "ul", "ol", "li", "a", "span", "div"], vr = ["href", "target", "rel"];
function Dr(e) {
  return e ? dr.sanitize(e, {
    ALLOWED_TAGS: br,
    ALLOWED_ATTR: vr,
    ALLOW_DATA_ATTR: !1
  }) : "";
}
const ie = (e) => e === !0 || e === 1 || e === "1", Or = (e) => {
  if (e === !0 || e === 1 || e === "1")
    return !0;
  if (e === !1 || e === 0 || e === "0")
    return !1;
}, Sr = (e) => !(e === !1 || e === 0 || e === "0"), Fr = (e) => {
  if (e == null)
    return;
  const r = String(e).trim();
  if (r)
    return r.replace(/\.0+$/, "");
};
function le(e) {
  return {
    globalId: String(e.GlobalID ?? ""),
    objectId: Number(e.ObjectId ?? 0),
    planId: e.PlanId ?? void 0,
    områdeId: e.OmrådeId ?? void 0,
    id: e.Id ?? void 0,
    parentId: e.ParentId ?? void 0,
    parentGlobalId: e.ParentGlobalID ?? void 0,
    seksjonstype: e.Seksjonstype ?? "Plan",
    tittel: e.Tittel ?? "",
    tekst: e.Tekst ?? "",
    synlig: Sr(e.Synlig),
    kommunal: ie(e.Kommunal),
    infoboks: ie(e.Infoboks),
    topp: Or(e.Topp),
    delområdetype: e.Delområdetype ?? void 0,
    områdeNavn: e.OmrådeNavn ?? void 0,
    prioritet: Number(e.Prioritet ?? 0),
    overstyrer: ie(e.Overstyrer),
    kommunenummer: Fr(e.Kommunenummer)
  };
}
function Ye(e) {
  return {
    GlobalID: void 0,
    PlanId: e.planId,
    OmrådeId: e.områdeId,
    Id: e.id,
    ParentId: e.parentId,
    ParentGlobalID: e.parentGlobalId,
    Seksjonstype: e.seksjonstype,
    Tittel: e.tittel,
    // ArcGIS rejecter HTML utenfor sin allowlist (f.eks. inline `style`
    // med `font-family`/`letter-spacing` fra ekstern paste). Sanering skjer
    // her, ved kanten mot infrastructure, slik at både ny og legacy-data
    // ryddes før applyEdits.
    Tekst: Dr(e.tekst),
    Synlig: e.synlig,
    Kommunal: e.kommunal,
    Infoboks: e.infoboks,
    Topp: e.topp,
    Delområdetype: e.delområdetype,
    OmrådeNavn: e.områdeNavn,
    Prioritet: e.prioritet,
    Overstyrer: e.overstyrer
  };
}
function Rr(e) {
  return {
    ...Ye(e),
    GlobalID: e.globalId,
    ObjectId: e.objectId
  };
}
function Er(e) {
  if (!e.seksjonUrl)
    throw new K(
      "createArcgisSeksjonRepository: seksjonUrl required"
    );
  let r = null;
  const t = () => (r ?? (r = new ne({ url: e.seksjonUrl })), r), n = async (o, s) => {
    try {
      return await o();
    } catch (d) {
      throw d instanceof Error && d.name === "AbortError" ? new T() : new k(`${s} feilet: ${d?.message ?? d}`, d);
    }
  };
  return {
    async fetch(o, s) {
      return n(async () => {
        const d = t().createQuery();
        return d.where = o, d.outFields = ["*"], d.orderByFields = ["Prioritet"], (await t().queryFeatures(d, { signal: s?.signal })).features.map(
          (l) => le(l.attributes)
        );
      }, "fetch seksjoner");
    },
    async fetchByGlobalId(o, s) {
      return n(async () => {
        const d = o.replace(/'/g, "''"), i = t().createQuery();
        i.where = `GlobalID='${d}'`, i.outFields = ["*"];
        const l = await t().queryFeatures(i, { signal: s?.signal });
        return l.features.length === 0 ? null : le(l.features[0].attributes);
      }, "fetchByGlobalId");
    },
    async add(o) {
      return n(async () => {
        const s = new S({ attributes: Ye(o) }), i = (await t().applyEdits({ addFeatures: [s] }))?.addFeatureResults?.[0];
        if (i?.error)
          throw new k(
            `Opprettelse feilet: ${i.error.message ?? ""}`,
            i.error
          );
        const l = i?.objectId;
        if (l == null)
          throw new k("Opprettelse feilet: mangler objectId i respons");
        const a = t().createQuery();
        a.where = `ObjectId=${l}`, a.outFields = ["*"];
        const m = (await t().queryFeatures(a)).features[0];
        if (!m)
          throw new k(
            "Opprettelse feilet: klarte ikke lese tilbake ny rad"
          );
        return le(m.attributes);
      }, "add seksjon");
    },
    async update(o) {
      return n(async () => {
        if (!o.globalId)
          throw new k("update: globalId mangler");
        const d = { updateFeatures: [new S({ attributes: Rr(o) })], useGlobalIds: !0 }, l = (await t().applyEdits(
          d
        ))?.updateFeatureResults?.[0];
        if (l?.error)
          throw new k(
            `Lagring feilet: ${l.error.message ?? ""}`,
            l.error
          );
        return o;
      }, "update seksjon");
    },
    async delete(o) {
      await n(
        () => t().applyEdits({
          deleteFeatures: [{ objectId: o }]
        }),
        "delete seksjon"
      );
    },
    async reorder(o) {
      o.length !== 0 && await n(async () => {
        const s = o.map((u) => u.objectId), d = t().createQuery();
        d.where = `ObjectId IN (${s.join(",")})`, d.outFields = ["*"];
        const i = await t().queryFeatures(d), l = new Map(o.map((u) => [u.objectId, u.prioritet])), a = i.features.map((u) => {
          const m = u.attributes.ObjectId;
          if (m == null)
            return null;
          const c = l.get(m);
          return c == null ? null : new S({
            attributes: { ...u.attributes, Prioritet: c }
          });
        }).filter((u) => u !== null);
        a.length !== 0 && await t().applyEdits({ updateFeatures: a });
      }, "reorder seksjoner");
    }
  };
}
async function zt(e, r, t) {
  const n = await e.fetchByGlobalId(r, t);
  if (!n)
    throw new oe(r);
  return n;
}
const Fe = {
  minRatio: 0.01,
  minAreaM2: 1 / 0
};
function ue(e) {
  try {
    return Math.abs(ar.execute(e, { unit: "square-meters" }));
  } catch {
    return 0;
  }
}
function Ar(e, r, t = {}) {
  if (!e || !r)
    return { keep: !0, reason: "missing-geometry" };
  const n = t.minAreaM2 ?? Fe.minAreaM2, o = t.minRatio ?? Fe.minRatio, s = e.spatialReference?.wkid, d = r.spatialReference?.wkid;
  if (s != null && d != null && s !== d)
    return { keep: !0, reason: "sr-mismatch", srcWkid: s, candWkid: d };
  const i = e, l = r;
  try {
    if (!lr.execute(i, l))
      return { keep: !1, reason: "no-intersect", srcWkid: s, candWkid: d };
  } catch {
    return { keep: !0, reason: "intersect-error", srcWkid: s, candWkid: d };
  }
  let a;
  try {
    a = ir.execute(i, l);
  } catch {
    return { keep: !0, reason: "intersection-error", srcWkid: s, candWkid: d };
  }
  if (!a)
    return s != null && d != null && s === d ? { keep: !1, reason: "touch-no-area", srcWkid: s, candWkid: d, overlapAreaM2: 0, ratio: 0 } : { keep: !0, reason: "intersection-null", srcWkid: s, candWkid: d };
  const u = ue(a), m = ue(e), c = ue(r), p = Math.min(m, c), f = p > 0 ? u / p : 0, g = { srcWkid: s, candWkid: d, overlapAreaM2: u, sourceAreaM2: m, candidateAreaM2: c, ratio: f };
  return f >= o ? { keep: !0, reason: "ratio-pass", ...g } : u >= n ? { keep: !0, reason: "area-pass", ...g } : { keep: !1, reason: "below-threshold", ...g };
}
function Nr(e, r, t = {}) {
  return Ar(e, r, t).keep;
}
function $r(e) {
  return e.split("'").join("''");
}
function h(e) {
  return `'${$r(e)}'`;
}
function _(e, r) {
  const t = Array.from(
    new Set(r.filter(Boolean).map((n) => n.trim()).filter(Boolean))
  );
  return t.length === 0 ? "" : t.length === 1 ? `${e}=${h(t[0])}` : `${e} IN (${t.map(h).join(", ")})`;
}
const xe = "​", er = "‌", Pr = [
  "Plan",
  "Delområdetype",
  "Delområdegruppe",
  "Delområde",
  "Område"
];
function Tr(e) {
  const r = typeof e == "string" ? e : "";
  if (r.startsWith(xe))
    return { kind: "delomradegruppe", navn: r.slice(1) };
  if (r.startsWith(er)) {
    const t = r.slice(1);
    return { kind: "delomradegruppe-member", navn: t, code: t };
  }
  return { kind: "egendefinert", navn: r };
}
function z(e) {
  return e.kind === "delomradegruppe" ? xe + e.navn : e.kind === "delomradegruppe-member" ? er + (e.code ?? e.navn) : e.navn;
}
function qr(e, r) {
  if (r == null || r === "")
    return {};
  const t = String(r), n = typeof e == "string" ? e : "", o = Pr.find((s) => s === n);
  return o ? { parentType: o, parentId: t } : { parentId: t };
}
function X(e, r) {
  const t = e.ObjectId ?? e.OBJECTID, n = String(e.Id ?? t ?? ""), { parentType: o, parentId: s } = qr(e.ParentType, e.ParentRef), d = Tr(e.Navn);
  return {
    id: n,
    objectId: t,
    kind: d.kind,
    navn: d.navn || `Område ${t ?? ""}`,
    planId: e.PlanId ?? "",
    parentType: o,
    parentId: s,
    code: d.code,
    geometry: r
  };
}
const me = Ge("seksjon:arcgisOmrådeRepository");
function Gr(e, r, t) {
  const n = e;
  if (!n?.features)
    return e;
  const o = n.spatialReference?.wkid ?? t, s = n.features.filter((d) => {
    if (!d.geometry)
      return !0;
    let i;
    try {
      i = Te.fromJSON(d.geometry);
    } catch {
      return !0;
    }
    return o != null && (i.spatialReference = new qe({ wkid: o })), Nr(r, i);
  });
  return { ...n, features: s };
}
function Cr(e) {
  const r = e.features ?? [], t = [
    "plan",
    "delomrade",
    "delomradegruppe",
    "egendefinert"
  ], n = [];
  for (const o of r) {
    const s = o.attributes ?? {}, d = s.omradeId == null ? "" : String(s.omradeId), i = s.omradetype, l = s.operation;
    if (!d || !i || !t.includes(i) || l !== "add" && l !== "remove")
      continue;
    const a = s.matrikkelenhetId, u = a == null || a === "" ? void 0 : Number(a), m = s.adresseId, c = m == null || m === "" ? void 0 : Number(m);
    n.push({
      omradeId: d,
      omradetype: i,
      operation: l,
      ...u != null && Number.isFinite(u) ? { matrikkelenhetId: u } : {},
      ...c != null && Number.isFinite(c) ? { adresseId: c } : {}
    });
  }
  return n;
}
function Kr(e) {
  if (!e.områderUrl)
    throw new K(
      "createArcgisOmrådeRepository: områderUrl required"
    );
  let r = null;
  const t = () => (r ?? (r = new ne({ url: e.områderUrl })), r), n = async (a, u) => {
    try {
      return await a();
    } catch (m) {
      throw m instanceof Error && m.name === "AbortError" ? new T() : new k(`${u} feilet: ${m?.message ?? m}`, m);
    }
  }, o = async (a) => {
    const u = t().createQuery();
    u.where = "1=1", u.outStatistics = [
      {
        statisticType: "max",
        onStatisticField: "Id",
        outStatisticFieldName: "MaxId"
      }
    ];
    const c = (await t().queryFeatures(u)).features[0]?.attributes?.MaxId, p = typeof c == "number" && Number.isFinite(c) ? c : 0;
    return Math.max(p, a) + 1;
  }, s = Cr, d = async (a, u) => {
    if (!e.eiendommerUrl)
      return [];
    const c = `${e.eiendommerUrl.replace(/\/$/, "")}/query`, p = a.toJSON?.() ?? a, f = a.spatialReference?.wkid;
    try {
      const g = await A(c, {
        method: "post",
        query: {
          f: "json",
          geometry: JSON.stringify(p),
          geometryType: "esriGeometryPolygon",
          // outSR = inSR slik at returnert geometri ligger i samme SR som
          // kilden og kan sammenlignes direkte av areal-filteret under.
          ...f != null ? { inSR: f, outSR: f } : {},
          spatialRel: "esriSpatialRelIntersects",
          where: "omradetype IN ('plan', 'delomrade', 'delomradegruppe', 'egendefinert') AND operation IN ('add', 'remove')",
          outFields: "omradeId,omradetype,operation,matrikkelenhetId,adresseId",
          returnGeometry: !0
        },
        signal: u?.signal
      }), F = Gr(
        g.data,
        a,
        f
      );
      return s(F);
    } catch (g) {
      if (g instanceof Error && g.name === "AbortError")
        throw new T();
      return me.warn("findOverridesByGeometry feilet:", g), [];
    }
  }, i = async (a, u) => {
    const m = [...new Set(a)].map((c) => Number(c)).filter((c) => Number.isFinite(c));
    return m.length === 0 ? [] : n(async () => {
      const c = t().createQuery();
      return c.where = `Id IN (${m.join(",")})`, c.outFields = ["*"], c.returnGeometry = !1, (await t().queryFeatures(c, {
        signal: u?.signal
      })).features.map(
        (f) => X(f.attributes)
      );
    }, "fetchOmrådeByIds");
  }, l = async (a) => {
    if (!e.eiendommerUrl)
      return;
    const u = e.eiendommerUrl.replace(/\/$/, ""), m = `${u}/query`, c = `omradeid = ${a} AND (omradetype = 'egendefinert' OR omradetype IS NULL)`, f = (await A(m, {
      method: "post",
      query: { f: "json", where: c, returnIdsOnly: !0 }
    })).data.objectIds ?? [];
    if (f.length === 0)
      return;
    const g = `${u}/applyEdits`;
    await A(g, {
      method: "post",
      query: { f: "json", deletes: f.join(",") }
    });
  };
  return {
    async fetchEgendefinerteForPlan(a, u) {
      return n(async () => {
        const m = t().createQuery();
        return m.where = `PlanId=${h(a)} AND ParentRef IS NOT NULL AND ParentRef <> ''`, m.outFields = ["*"], (await t().queryFeatures(m, {
          signal: u?.signal
        })).features.map(
          (p) => X(p.attributes)
        );
      }, "fetch egendefinerte områder");
    },
    async findOverlappingGeometry(a, u, m) {
      return n(async () => {
        const c = t().createQuery();
        return c.geometry = a, c.spatialRelationship = "intersects", c.outFields = ["*"], c.returnGeometry = !0, u && (c.where = `PlanId=${h(u)}`), (await t().queryFeatures(c, {
          signal: m?.signal
        })).features.map(
          (f) => X(
            f.attributes,
            f.geometry
          )
        );
      }, "findOverlappingGeometry");
    },
    async resolveAncestry(a, u, m) {
      const c = t().createQuery();
      c.where = `PlanId=${h(u)} AND ParentRef IS NOT NULL AND ParentRef <> ''`, c.outFields = ["*"];
      const f = (await t().queryFeatures(c, {
        signal: m?.signal
      })).features.map(
        (g) => X(g.attributes)
      );
      return H(a, u, f, []);
    },
    async findOverridesForTeig(a, u, m) {
      if (!e.eiendommerUrl || !Number.isFinite(a))
        return [];
      const p = `${e.eiendommerUrl.replace(/\/$/, "")}/query`;
      try {
        const f = await A(p, {
          method: "post",
          query: {
            f: "json",
            where: `teigId = ${a}`,
            outFields: "omradeId,omradetype,operation,matrikkelenhetId,adresseId",
            returnGeometry: !1
          },
          signal: m?.signal
        });
        return s(f.data);
      } catch (f) {
        if (f instanceof Error && f.name === "AbortError")
          throw new T();
        return me.warn("findOverridesForTeig feilet:", f), [];
      }
    },
    findOverridesByGeometry: d,
    fetchOmrådeByIds: i,
    async findEgendefinerteByGeometry(a, u) {
      const c = (await d(a, u)).filter((p) => p.omradetype === "egendefinert" && p.operation === "add").map((p) => p.omradeId);
      return c.length === 0 ? [] : i(c, u);
    },
    async add(a) {
      return n(async () => {
        const u = a.kind ?? "egendefinert", m = z({
          kind: u,
          navn: a.navn,
          code: a.code
        }), c = new S({
          attributes: {
            Navn: m,
            PlanId: a.planId,
            ...a.parentType ? { ParentType: a.parentType } : {},
            ...a.parentId ? { ParentRef: a.parentId } : {}
          }
        }), f = (await t().applyEdits({
          addFeatures: [c]
        })).addFeatureResults?.[0];
        if (!f || f.error)
          throw new k(
            f?.error?.message ?? "Failed to add område",
            f?.error
          );
        const g = f.objectId, F = await o(g), y = new S({
          attributes: { ObjectId: g, Id: F }
        }), N = (await t().applyEdits({
          updateFeatures: [y]
        })).updateFeatureResults?.[0];
        if (N?.error)
          throw new k(
            N.error.message ?? "Failed to initialize område Id",
            N.error
          );
        return {
          id: String(F),
          objectId: g,
          kind: u,
          navn: a.navn,
          planId: a.planId,
          parentType: a.parentType,
          parentId: a.parentId,
          code: a.code
        };
      }, "add område");
    },
    async update(a) {
      return n(async () => {
        const u = { ObjectId: a.objectId };
        if ("navn" in a) {
          const f = a.kind ?? "egendefinert";
          u.Navn = z({
            kind: f,
            navn: a.navn ?? "",
            code: a.code
          });
        }
        "parentType" in a && (u.ParentType = a.parentType), "parentId" in a && (u.ParentRef = a.parentId);
        const m = new S({ attributes: u }), p = (await t().applyEdits({
          updateFeatures: [m]
        })).updateFeatureResults?.[0];
        if (p?.error)
          throw new k(
            p.error.message ?? "Failed to update område",
            p.error
          );
        return {
          id: a.id ?? "",
          objectId: a.objectId,
          kind: a.kind ?? "egendefinert",
          navn: a.navn ?? "",
          planId: a.planId ?? "",
          parentType: a.parentType,
          parentId: a.parentId
        };
      }, "update område");
    },
    async delete(a, u) {
      await n(async () => {
        const m = Number(u);
        if (Number.isFinite(m))
          try {
            await l(m);
          } catch (f) {
            me.warn("Kunne ikke rydde opp eiendommer-deltaer:", f);
          }
        const p = (await t().applyEdits({
          deleteFeatures: [{ objectId: a }]
        })).deleteFeatureResults?.[0];
        if (p?.error)
          throw new k(
            p.error.message ?? "Failed to delete område",
            p.error
          );
      }, "delete område");
    }
  };
}
function Re(e) {
  return {
    objectId: Number(e.OBJECTID ?? 0),
    seksjonsGlobalId: String(e.SeksjonsGlobalID ?? ""),
    filId: e.FilId ?? void 0,
    tittel: e.Tittel ?? void 0,
    beskrivelse: e.Beskrivelse ?? void 0,
    prioritet: Number(e.Prioritet ?? 0)
  };
}
function Br(e) {
  return {
    SeksjonsGlobalID: e.seksjonsGlobalId,
    FilId: e.filId,
    Tittel: e.tittel,
    Beskrivelse: e.beskrivelse,
    Prioritet: e.prioritet
  };
}
function Mr(e) {
  if (!e.seksjonelementUrl)
    throw new K(
      "createArcgisSeksjonelementRepository: seksjonelementUrl required"
    );
  let r = null;
  const t = async () => (r || (r = new ne({
    url: e.seksjonelementUrl,
    refreshInterval: 0
  }), await r.load()), r), n = async (o, s) => {
    try {
      return await o();
    } catch (d) {
      throw d instanceof Error && d.name === "AbortError" ? new T() : new k(`${s} feilet: ${d?.message ?? d}`, d);
    }
  };
  return {
    async fetchForSection(o, s) {
      return n(async () => {
        const d = await t(), i = d.createQuery();
        return i.where = `SeksjonsGlobalID = ${h(o)}`, i.outFields = ["*"], i.returnGeometry = !1, i.orderByFields = ["Prioritet"], (await d.queryFeatures(i, { signal: s?.signal })).features.map((a) => ({
          ...Re(a.attributes),
          objectId: Number(a.getObjectId())
        }));
      }, "fetchForSection");
    },
    async add(o) {
      return n(async () => {
        const s = await t(), d = new S({
          attributes: Br(o)
        }), l = (await s.applyEdits({ addFeatures: [d] })).addFeatureResults?.[0];
        if (!l || l.error)
          throw new k(
            l?.error?.message ?? "Failed to add element",
            l?.error
          );
        const a = s.createQuery();
        a.where = `OBJECTID = ${l.objectId}`, a.outFields = ["*"], a.returnGeometry = !1;
        const m = (await s.queryFeatures(a)).features[0];
        if (!m)
          throw new k(
            `Element med objectId ${l.objectId} ikke funnet etter insertion`
          );
        return {
          ...Re(m.attributes),
          objectId: Number(m.getObjectId())
        };
      }, "add element");
    },
    async update(o, s) {
      await n(async () => {
        const d = await t(), i = new S({
          attributes: {
            OBJECTID: o,
            Tittel: s.tittel,
            Beskrivelse: s.beskrivelse
          }
        }), a = (await d.applyEdits({ updateFeatures: [i] })).updateFeatureResults?.[0];
        if (a?.error)
          throw new k(
            a.error.message ?? "Failed to update element",
            a.error
          );
      }, "update element");
    },
    async delete(o) {
      await n(async () => {
        const s = await t(), i = (await s.applyEdits({
          deleteFeatures: [new S({ attributes: { [s.objectIdField]: o } })]
        })).deleteFeatureResults?.[0];
        if (i?.error)
          throw new k(
            i.error.message ?? "Failed to delete element",
            i.error
          );
      }, "delete element");
    },
    async reorder(o) {
      o.length !== 0 && await n(async () => {
        const s = await t(), d = o.map(
          (a) => new S({
            attributes: {
              OBJECTID: a.objectId,
              Prioritet: a.prioritet
            }
          })
        ), l = ((await s.applyEdits({ updateFeatures: d })).updateFeatureResults ?? []).filter((a) => a.error);
        if (l.length > 0)
          throw new k(
            `Failed to reorder elements: ${l.map((a) => a.error?.message).join(", ")}`
          );
      }, "reorder elements");
    }
  };
}
const Ee = "​", Y = "‌";
function _r(e) {
  if (!e.områderUrl)
    throw new K(
      "createArcgisDelområdegruppeRepository: områderUrl required"
    );
  let r = null;
  const t = () => (r ?? (r = new ne({ url: e.områderUrl })), r), n = async (o, s) => {
    try {
      return await o();
    } catch (d) {
      throw d instanceof Error && d.name === "AbortError" ? new T() : new k(`${s} feilet: ${d?.message ?? d}`, d);
    }
  };
  return {
    async fetchForPlan(o, s) {
      return n(async () => {
        const d = t().createQuery();
        d.where = `PlanId=${h(o)} AND Navn LIKE '${Ee}%'`, d.outFields = ["*"];
        const i = await t().queryFeatures(d, {
          signal: s?.signal
        }), l = [];
        for (const a of i.features) {
          const u = a.attributes, m = u.ObjectId ?? u.OBJECTID, c = String(u.Id ?? m), p = typeof u.Navn == "string" ? u.Navn : "", f = p.startsWith(Ee) ? p.slice(1) : p;
          if (!m)
            continue;
          const g = t().createQuery();
          g.where = `PlanId=${h(o)} AND ParentRef=${h(c)} AND Navn LIKE '${Y}%'`, g.outFields = ["*"];
          const y = (await t().queryFeatures(g, {
            signal: s?.signal
          })).features.map((O) => {
            const N = O.attributes, Z = typeof N.Navn == "string" ? N.Navn : "";
            return Z.startsWith(Y) ? Z.slice(1) : "";
          }).filter(Boolean);
          l.push({
            id: c,
            objectId: m,
            planId: o,
            delområdetype: "",
            navn: f,
            medlemmer: y
          });
        }
        return l;
      }, "fetchForPlan delområdegrupper");
    },
    async create(o) {
      return n(async () => {
        const s = z({
          kind: "delomradegruppe",
          navn: o.navn
        }), d = new S({
          attributes: {
            Navn: s,
            PlanId: o.planId,
            ParentType: "Delområdetype",
            ParentRef: o.delområdetype
          }
        }), l = (await t().applyEdits({
          addFeatures: [d]
        })).addFeatureResults?.[0];
        if (!l || l.error)
          throw new k(
            l?.error?.message ?? "Failed to create delområdegruppe",
            l?.error
          );
        const a = l.objectId;
        return o.medlemmer && o.medlemmer.length > 0 && await this.addMembers({
          gruppeId: String(a),
          planId: o.planId,
          medlemmer: o.medlemmer
        }), {
          id: String(a),
          objectId: a,
          planId: o.planId,
          delområdetype: o.delområdetype,
          navn: o.navn,
          medlemmer: o.medlemmer ?? []
        };
      }, "create delområdegruppe");
    },
    async addMembers({ gruppeId: o, planId: s, medlemmer: d }) {
      d.length !== 0 && await n(async () => {
        const i = d.map(
          (u) => new S({
            attributes: {
              Navn: z({
                kind: "delomradegruppe-member",
                navn: u,
                code: u
              }),
              PlanId: s,
              ParentType: "Område",
              ParentRef: o
            }
          })
        ), a = ((await t().applyEdits({
          addFeatures: i
        })).addFeatureResults ?? []).filter((u) => u.error);
        if (a.length > 0)
          throw new k(
            `Failed to add ${a.length} members: ${a.map((u) => u.error?.message).join(", ")}`
          );
      }, "addMembers");
    },
    async removeMembers({ gruppeId: o, planId: s, medlemmer: d }) {
      d.length !== 0 && await n(async () => {
        const i = d.map(
          (p) => `Navn=${h(Y + p)}`
        ).join(" OR "), l = t().createQuery();
        l.where = `PlanId=${h(s)} AND ParentRef=${h(o)} AND (${i})`, l.outFields = ["OBJECTID"];
        const u = (await t().queryFeatures(l)).features.map((p) => p.attributes.OBJECTID).filter((p) => p != null);
        if (u.length === 0)
          return;
        const c = ((await t().applyEdits({
          deleteFeatures: u.map(
            (p) => ({ objectId: p })
          )
        })).deleteFeatureResults ?? []).filter((p) => p.error);
        if (c.length > 0)
          throw new k(
            `Failed to remove ${c.length} members`,
            c
          );
      }, "removeMembers");
    },
    async rename({ gruppeObjectId: o, navn: s }) {
      await n(async () => {
        const d = new S({
          attributes: {
            OBJECTID: o,
            Navn: z({ kind: "delomradegruppe", navn: s })
          }
        }), l = (await t().applyEdits({
          updateFeatures: [d]
        })).updateFeatureResults?.[0];
        if (l?.error)
          throw new k(
            l.error.message ?? "Failed to rename delområdegruppe",
            l.error
          );
      }, "rename delområdegruppe");
    },
    async delete({ gruppeObjectId: o, gruppeId: s }) {
      await n(async () => {
        const d = t().createQuery();
        d.where = `ParentRef=${h(s)} AND Navn LIKE '${Y}%'`, d.outFields = ["OBJECTID"];
        const l = (await t().queryFeatures(d)).features.map((m) => m.attributes.OBJECTID).filter((m) => m != null);
        l.length > 0 && await t().applyEdits({
          deleteFeatures: l.map(
            (m) => ({ objectId: m })
          )
        });
        const u = (await t().applyEdits({
          deleteFeatures: [
            { objectId: o }
          ]
        })).deleteFeatureResults?.[0];
        if (u?.error)
          throw new k(
            u.error.message ?? "Failed to delete delområdegruppe",
            u.error
          );
      }, "delete delområdegruppe");
    }
  };
}
function Ht(e) {
  if (!e.seksjonUrl)
    throw new K("createSeksjonClient: seksjonUrl required");
  const r = Er({ seksjonUrl: e.seksjonUrl }), t = e.områderUrl ? Kr({
    områderUrl: e.områderUrl,
    eiendommerUrl: e.eiendommerUrl
  }) : void 0, n = e.seksjonelementUrl ? Mr({
    seksjonelementUrl: e.seksjonelementUrl
  }) : void 0, o = e.områderUrl ? _r({ områderUrl: e.områderUrl }) : void 0;
  return { seksjoner: r, områder: t, elementer: n, delområdegrupper: o };
}
const I = {
  all: ["seksjon"],
  seksjoner: {
    all: ["seksjon", "seksjoner"],
    forContext: (e, r = "filtered") => r === "filtered" ? ["seksjon", "seksjoner", Se(e)] : ["seksjon", "seksjoner", Se(e), "raw"],
    byGlobalId: (e) => ["seksjon", "seksjon", e]
  },
  elementer: {
    all: ["seksjon", "elementer"],
    forSeksjon: (e) => ["seksjon", "elementer", e]
  },
  områder: {
    all: ["seksjon", "områder"],
    forPlan: (e) => ["seksjon", "områder", e],
    ancestry: (e, r) => ["seksjon", "områder", "ancestry", e, r]
  },
  delområdegrupper: {
    all: ["seksjon", "delområdegrupper"],
    forPlan: (e) => ["seksjon", "delområdegrupper", e]
  }
};
function Ur(e, r = {}) {
  const t = [];
  switch (t.push(Lr()), e.type) {
    case "Kommune":
      break;
    case "Plan":
      t.push(`(PlanId=${h(e.planId)} AND Seksjonstype='Plan')`);
      break;
    case "Delområdetype":
      t.push(`(PlanId=${h(e.planId)} AND Seksjonstype='Plan')`), t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdetype' AND ${x(
          [e.delområdetype, ...r.delområdetypeCandidates ?? []]
        )})`
      );
      break;
    case "Delområdegruppe": {
      t.push(`(PlanId=${h(e.planId)} AND Seksjonstype='Plan')`);
      const n = [
        e.delområdetype,
        ...r.delområdetypeCandidates ?? []
      ], o = x(n);
      o && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdetype' AND ${o})`
      ), t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdegruppe' AND OmrådeId=${h(e.gruppeId)})`
      );
      break;
    }
    case "Delområde": {
      t.push(`(PlanId=${h(e.planId)} AND Seksjonstype='Plan')`);
      const n = [
        ...e.delområdetype ? [e.delområdetype] : [],
        ...r.delområdetypeCandidates ?? []
      ], o = x(n);
      o && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdetype' AND ${o})`
      );
      const s = _("OmrådeId", r.ancestry?.gruppeIds ?? []);
      s && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdegruppe' AND ${s})`
      );
      const d = [e.områdeId, ...r.områdeIdCandidates ?? []], i = _("OmrådeId", d);
      i && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområde' AND ${i})`
      );
      break;
    }
    case "Område": {
      t.push(`(PlanId=${h(e.planId)} AND Seksjonstype='Plan')`);
      const n = [
        ...r.delområdetypeCandidates ?? [],
        ...r.ancestry?.delområdetyper ?? []
      ], o = x(n);
      o && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdetype' AND ${o})`
      );
      const s = _(
        "OmrådeId",
        r.ancestry?.gruppeIds ?? []
      );
      s && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområdegruppe' AND ${s})`
      );
      const d = _(
        "OmrådeId",
        r.ancestry?.delområdeIds ?? []
      );
      d && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Delområde' AND ${d})`
      );
      const i = [
        e.områdeId,
        ...r.ancestry?.ancestorOmrådeIds ?? [],
        ...r.områdeIdCandidates ?? []
      ], l = _("OmrådeId", i);
      l && t.push(
        `(PlanId=${h(e.planId)} AND Seksjonstype='Område' AND ${l})`
      );
      break;
    }
  }
  return t.join(" OR ");
}
function Lr() {
  return "(Seksjonstype='Kommune' OR Kommunal=1)";
}
function x(e) {
  const r = Array.from(
    new Set(e.filter(Boolean).map((n) => n.trim()).filter(Boolean))
  );
  if (r.length === 0)
    return "";
  const t = r.map((n) => /^\d+$/.test(n) ? `(Delområdetype=${h(n)} OR Delområdetype LIKE ${h(n + " -%")})` : `Delområdetype=${h(n)}`);
  return t.length === 1 ? t[0] : `(${t.join(" OR ")})`;
}
async function re({ seksjonRepo: e, områdeRepo: r }, {
  context: t,
  ancestry: n,
  områdeIdCandidates: o,
  delområdetypeCandidates: s,
  includeOverriddenAncestors: d,
  synligOnly: i
}, l) {
  const a = await Qr(
    t,
    n,
    r,
    l
  ), u = Ur(t, {
    ancestry: a,
    områdeIdCandidates: o,
    delområdetypeCandidates: s
  }), m = await e.fetch(u, l), c = d ? m : Ue(m, je(m)), p = [], f = [];
  t.type === "Delområdetype" ? (f.push(t.delområdetype), s && f.push(...s)) : t.type === "Delområdegruppe" ? (p.push(t.gruppeId), f.push(t.delområdetype), s && f.push(...s)) : (t.type === "Delområde" || t.type === "Område") && (p.push(t.områdeId), o && p.push(...o), t.type === "Delområde" && t.delområdetype && f.push(t.delområdetype));
  const g = Le(c, t, {
    områdeIdCandidates: p,
    delområdetypeCandidates: f,
    ancestorDelområdeIds: a?.delområdeIds,
    ancestorGruppeIds: a?.gruppeIds
  });
  return i ? g.filter((F) => F.synlig) : g;
}
async function Qr(e, r, t, n) {
  if (r)
    return r;
  if (t) {
    if (e.type === "Område")
      return t.resolveAncestry(e.områdeId, e.planId, n);
    if (e.type === "Delområde") {
      const o = await t.fetchEgendefinerteForPlan(e.planId, n);
      return be(e.områdeId, e.planId, o, []);
    }
  }
}
const Wr = j.object({
  planId: j.string().trim().optional(),
  områdeId: j.string().trim().optional(),
  id: j.string().trim().optional(),
  parentId: j.string().trim().optional(),
  parentGlobalId: j.string().trim().optional(),
  seksjonstype: j.enum(
    jr
  ),
  tittel: j.string().trim().min(1, "Tittel kreves").max(200, "Tittel maks 200 tegn"),
  tekst: j.string().max(2e4, "Tekst er for lang"),
  synlig: j.boolean().default(!0),
  kommunal: j.boolean().default(!1),
  infoboks: j.boolean().default(!1),
  topp: j.boolean().optional(),
  delområdetype: j.string().optional(),
  områdeNavn: j.string().optional(),
  prioritet: j.number().int().nonnegative(),
  overstyrer: j.boolean().default(!1)
}), Vt = j.object({
  tittel: j.string().trim().min(1, "Tittel kreves").max(200),
  tekst: j.string().max(2e4),
  topp: j.boolean().optional(),
  infoboks: j.boolean().default(!1)
});
async function Jr({ seksjonRepo: e }, { values: r, editing: t }) {
  if (t)
    return e.update({
      ...t,
      ...r
    });
  const n = Wr.safeParse(r);
  if (!n.success) {
    const o = {};
    for (const s of n.error.issues) {
      const d = s.path.join(".");
      d && (o[d] = s.message);
    }
    throw new G("Ugyldig seksjonsinput", o);
  }
  return e.add(r);
}
async function zr({ seksjonRepo: e }, r) {
  await e.delete(r.objectId);
}
async function Hr({ seksjonRepo: e, elementRepo: r }, { sourceGlobalId: t, enable: n, context: o }, s) {
  const d = await e.fetchByGlobalId(t, s);
  if (!d)
    throw new oe(t);
  const i = Vr(d, o);
  if (d.parentGlobalId && i) {
    if (d.overstyrer === n)
      return { action: "already-in-state", section: d };
    const m = await e.update({ ...d, overstyrer: n });
    return {
      action: n ? "activated-existing" : "deactivated",
      section: m
    };
  }
  if (!n)
    return { action: "already-in-state", section: d };
  const l = await Zr(
    e,
    t,
    o,
    s
  );
  if (l)
    return { action: "activated-existing", section: await e.update({ ...l, overstyrer: !0 }) };
  const a = Xr(o), u = await e.add({
    ...d,
    seksjonstype: a,
    planId: Yr(o) ?? d.planId,
    områdeId: xr(o) ?? d.områdeId,
    delområdetype: o.type === "Delområdetype" || o.type === "Delområdegruppe" || o.type === "Delområde" ? o.delområdetype : d.delområdetype,
    parentGlobalId: d.globalId,
    parentId: d.id,
    overstyrer: !0,
    synlig: !0,
    kommunal: o.type === "Kommune" ? d.kommunal : !1
    // ObjectId/GlobalID are system-assigned.
  });
  if (r && d.globalId && u.globalId) {
    const m = await r.fetchForSection(d.globalId, s);
    for (const c of m)
      await r.add({
        seksjonsGlobalId: u.globalId,
        filId: c.filId,
        tittel: c.tittel,
        beskrivelse: c.beskrivelse,
        prioritet: c.prioritet
      });
  }
  return { action: "created", section: u };
}
function Vr(e, r) {
  switch (r.type) {
    case "Kommune":
      return e.seksjonstype === "Kommune" || e.kommunal;
    case "Plan":
      return e.seksjonstype === "Plan" && e.planId === r.planId;
    case "Delområdetype":
      return e.seksjonstype === "Delområdetype" && e.planId === r.planId && e.delområdetype === r.delområdetype;
    case "Delområdegruppe":
      return e.seksjonstype === "Delområdegruppe" && e.planId === r.planId && e.områdeId === r.gruppeId && e.delområdetype === r.delområdetype;
    case "Delområde":
      return e.seksjonstype === "Delområde" && e.planId === r.planId && e.områdeId === r.områdeId;
    case "Område":
      return e.seksjonstype === "Område" && e.planId === r.planId && e.områdeId === r.områdeId;
  }
}
async function Zr(e, r, t, n) {
  const s = [`ParentGlobalID='${r.split("'").join("''")}'`, "Overstyrer=0"];
  return (t.type === "Plan" || t.type === "Delområdetype" || t.type === "Delområdegruppe" || t.type === "Delområde" || t.type === "Område") && s.push(`PlanId='${t.planId.split("'").join("''")}'`), (t.type === "Delområdetype" || t.type === "Delområdegruppe") && s.push(`Delområdetype='${t.delområdetype.split("'").join("''")}'`), t.type === "Delområdegruppe" && s.push(`OmrådeId='${t.gruppeId.split("'").join("''")}'`), (t.type === "Delområde" || t.type === "Område") && s.push(`OmrådeId='${t.områdeId.split("'").join("''")}'`), (await e.fetch(s.join(" AND "), n))[0] ?? null;
}
function Xr(e) {
  switch (e.type) {
    case "Kommune":
      return "Kommune";
    case "Plan":
      return "Plan";
    case "Delområdetype":
      return "Delområdetype";
    case "Delområdegruppe":
      return "Delområdegruppe";
    case "Delområde":
      return "Delområde";
    case "Område":
      return "Område";
  }
}
function Yr(e) {
  return e.type === "Kommune" ? void 0 : e.planId;
}
function xr(e) {
  if (e.type === "Delområdegruppe")
    return e.gruppeId;
  if (e.type === "Delområde" || e.type === "Område")
    return e.områdeId;
}
function et(e) {
  switch (e.type) {
    case "Kommune":
      return { seksjonstype: "Kommune", planId: void 0, områdeId: void 0, delområdetype: void 0 };
    case "Plan":
      return { seksjonstype: "Plan", planId: e.planId, områdeId: void 0, delområdetype: void 0 };
    case "Delområdetype":
      return { seksjonstype: "Delområdetype", planId: e.planId, områdeId: void 0, delområdetype: e.delområdetype };
    case "Delområdegruppe":
      return { seksjonstype: "Delområdegruppe", planId: e.planId, områdeId: e.gruppeId, delområdetype: e.delområdetype };
    case "Delområde":
      return { seksjonstype: "Delområde", planId: e.planId, områdeId: e.områdeId, delområdetype: e.delområdetype };
    case "Område":
      return { seksjonstype: "Område", planId: e.planId, områdeId: e.områdeId, delområdetype: void 0 };
  }
}
async function rt({ seksjonRepo: e }, { sourceGlobalId: r, context: t }, n) {
  const o = await e.fetchByGlobalId(r, n);
  if (!o)
    throw new oe(r);
  const { seksjonstype: s, planId: d, områdeId: i, delområdetype: l } = et(t);
  return { hideObjectId: (await e.add({
    seksjonstype: s,
    planId: d,
    områdeId: i,
    delområdetype: l,
    tittel: o.tittel,
    tekst: "",
    synlig: !1,
    kommunal: s === "Kommune",
    infoboks: !1,
    topp: !1,
    prioritet: 0,
    overstyrer: !1,
    parentGlobalId: o.globalId,
    parentId: o.id
  })).objectId };
}
async function tt({ seksjonRepo: e }, { hideObjectId: r }) {
  await e.delete(r);
}
async function nt({ seksjonRepo: e }, { ordered: r }) {
  const t = Qe(r);
  t.length !== 0 && await e.reorder(t);
}
async function ot({ områdeRepo: e }, r, t) {
  return e.fetchEgendefinerteForPlan(r.planId, t);
}
function Zt(e) {
  return H(
    e.områdeId,
    e.planId,
    e.egendefinerte,
    e.delområder
  );
}
async function st({ områdeRepo: e }, r, t) {
  return e.resolveAncestry(r.områdeId, r.planId, t);
}
async function dt({ områdeRepo: e }, r) {
  return e.add(r);
}
async function at({ områdeRepo: e }, r) {
  if (!r.objectId)
    throw new Ce(String(r.objectId));
  return e.update(r);
}
async function it({ områdeRepo: e }, r) {
  await e.delete(r.objectId, r.områdeId);
}
async function lt({ elementRepo: e }, r, t) {
  return e.fetchForSection(r.sectionGlobalId, t);
}
async function ut({ elementRepo: e }, r) {
  return e.add(r);
}
async function mt({ elementRepo: e }, r) {
  await e.update(r.objectId, {
    tittel: r.tittel,
    beskrivelse: r.beskrivelse
  });
}
async function ct({ elementRepo: e }, r) {
  await e.delete(r.objectId);
}
async function pt({ elementRepo: e }, r) {
  r.ordered.length !== 0 && await e.reorder([...r.ordered]);
}
async function ft({ områdeRepo: e }, r, t) {
  const n = await e.fetchEgendefinerteForPlan(r.planId, t), o = n.filter((d) => d.kind === "delomradegruppe"), s = n.filter((d) => d.kind === "delomradegruppe-member");
  return { grupper: o, medlemmer: s };
}
async function yt(e, r, t) {
  const { områdeRepo: n } = e, o = r.navn.trim();
  if (!o)
    throw new G("Gruppen må ha et navn", { navn: "Påkrevd" });
  if (r.memberDelområdeIds.length === 0)
    throw new G("Gruppen må ha minst ett medlem", {
      members: "Velg minst ett delområde"
    });
  await rr(e, r.planId, r.memberDelområdeIds, t);
  const s = await n.add({
    navn: o,
    planId: r.planId,
    kind: "delomradegruppe",
    parentType: "Delområdetype",
    parentId: r.delområdetype
  }), d = await Promise.all(
    r.memberDelområdeIds.map(
      (i) => n.add({
        navn: `${s.id}:${i}`,
        planId: r.planId,
        kind: "delomradegruppe-member",
        parentType: "Område",
        parentId: s.id,
        code: i
      })
    )
  );
  return { gruppe: s, members: d };
}
async function It(e, r, t) {
  return r.delområdeIds.length === 0 ? [] : (await rr(e, r.planId, r.delområdeIds, t, r.gruppeId), Promise.all(
    r.delområdeIds.map(
      (n) => e.områdeRepo.add({
        navn: `${r.gruppeId}:${n}`,
        planId: r.planId,
        kind: "delomradegruppe-member",
        parentType: "Område",
        parentId: r.gruppeId,
        code: n
      })
    )
  ));
}
async function gt({ områdeRepo: e }, r, t) {
  if (r.delområdeIds.length === 0)
    return;
  const n = await e.fetchEgendefinerteForPlan(r.planId, t), o = new Set(r.delområdeIds), s = n.filter(
    (d) => d.kind === "delomradegruppe-member" && d.parentId === r.gruppeId && !!d.code && o.has(d.code)
  );
  for (const d of s)
    d.objectId != null && await e.delete(d.objectId, d.id);
}
async function ht({ områdeRepo: e }, r) {
  const t = r.navn.trim();
  if (!t)
    throw new G("Gruppen må ha et navn", { navn: "Påkrevd" });
  return e.update({
    objectId: r.objectId,
    id: r.id,
    planId: r.planId,
    navn: t,
    kind: "delomradegruppe"
  });
}
async function kt(e, r, t) {
  const { områdeRepo: n, seksjonRepo: o } = e, d = (await n.fetchEgendefinerteForPlan(r.planId, t)).filter(
    (i) => i.kind === "delomradegruppe-member" && i.parentId === r.gruppe.id
  );
  for (const i of d)
    i.objectId != null && await n.delete(i.objectId, i.id);
  if (o) {
    const i = `PlanId='${r.planId.replace(/'/g, "''")}' AND Seksjonstype='Delområdegruppe' AND OmrådeId='${r.gruppe.id.replace(/'/g, "''")}'`, l = await o.fetch(i, t);
    for (const a of l)
      await o.delete(a.objectId);
  }
  await n.delete(r.gruppe.objectId, r.gruppe.id);
}
async function rr({ områdeRepo: e }, r, t, n, o) {
  const s = await e.fetchEgendefinerteForPlan(r, n), d = new Set(t), i = [];
  for (const l of s)
    l.kind === "delomradegruppe-member" && (o && l.parentId === o || l.code && d.has(l.code) && i.push(l.code));
  if (i.length > 0)
    throw new G(
      `Delområde(r) er allerede medlem av en annen gruppe: ${i.join(", ")}`,
      { members: "Allerede medlem" }
    );
}
const U = 6e4, wt = 3e4, jt = (e) => ({
  seksjoner: {
    forContext: (r, t = {}) => {
      const n = t.includeOverriddenAncestors ? "raw" : "filtered";
      return q({
        queryKey: r ? I.seksjoner.forContext(r, n) : I.seksjoner.forContext({ type: "Kommune" }, n),
        queryFn: ({ signal: o }) => {
          const s = {
            context: r,
            ancestry: t.ancestry,
            områdeIdCandidates: t.områdeIdCandidates,
            delområdetypeCandidates: t.delområdetypeCandidates,
            includeOverriddenAncestors: t.includeOverriddenAncestors
          };
          return re(
            {
              seksjonRepo: e.seksjonRepo,
              områdeRepo: e.områdeRepo
            },
            s,
            { signal: o }
          );
        },
        enabled: r != null,
        staleTime: wt
      });
    },
    byGlobalId: (r) => q({
      queryKey: I.seksjoner.byGlobalId(r ?? ""),
      queryFn: ({ signal: t }) => e.seksjonRepo.fetchByGlobalId(r, { signal: t }),
      enabled: !!r,
      staleTime: U
    })
  },
  elementer: {
    forSeksjon: (r) => q({
      queryKey: I.elementer.forSeksjon(r ?? ""),
      queryFn: ({ signal: t }) => {
        if (!e.elementRepo)
          throw new Error("elementRepo ikke konfigurert");
        return lt(
          { elementRepo: e.elementRepo },
          { sectionGlobalId: r },
          { signal: t }
        );
      },
      enabled: !!r && e.elementRepo != null,
      staleTime: U
    })
  },
  områder: {
    forPlan: (r) => q({
      queryKey: I.områder.forPlan(r ?? ""),
      queryFn: ({ signal: t }) => {
        if (!e.områdeRepo)
          throw new Error("områdeRepo ikke konfigurert");
        return ot(
          { områdeRepo: e.områdeRepo },
          { planId: r },
          { signal: t }
        );
      },
      enabled: !!r && e.områdeRepo != null,
      staleTime: U
    }),
    ancestry: (r, t) => q({
      queryKey: I.områder.ancestry(r ?? "", t ?? ""),
      queryFn: ({ signal: n }) => {
        if (!e.områdeRepo)
          throw new Error("områdeRepo ikke konfigurert");
        return st(
          { områdeRepo: e.områdeRepo },
          { områdeId: t, planId: r },
          { signal: n }
        );
      },
      enabled: !!(r && t) && e.områdeRepo != null,
      staleTime: U
    })
  },
  delområdegrupper: {
    forPlan: (r) => q({
      queryKey: I.delområdegrupper.forPlan(r ?? ""),
      queryFn: ({ signal: t }) => {
        if (!e.områdeRepo)
          throw new Error("områdeRepo ikke konfigurert");
        return ft(
          { områdeRepo: e.områdeRepo },
          { planId: r },
          { signal: t }
        );
      },
      enabled: !!r && e.områdeRepo != null,
      staleTime: U
    })
  }
}), bt = Ge("seksjon:arcgisAvvikRepository");
function E(e, ...r) {
  for (const n of r)
    if (e[n] != null)
      return e[n];
  const t = new Set(r.map((n) => n.toLowerCase()));
  for (const [n, o] of Object.entries(e))
    if (o != null && t.has(n.toLowerCase()))
      return o;
}
function ce(e) {
  if (!(e == null || e === ""))
    return Number(e);
}
function vt(e, r, t) {
  const n = e.attributes ?? {}, o = E(n, "operation");
  if (o !== "add" && o !== "remove")
    return;
  const s = ce(E(n, "teigId"));
  if (s !== void 0 && !Number.isFinite(s))
    return;
  const d = ce(E(n, "matrikkelenhetId"));
  if (d !== void 0 && !Number.isFinite(d))
    return;
  const i = E(n, "omradeId", "omradeid", "områdeid"), l = i == null || i === "" ? r.omradeId : String(i), a = E(n, "omradetype"), u = typeof a == "string" && a !== "" ? a : r.omradetype;
  let m;
  e.geometry && (m = Te.fromJSON(e.geometry), t != null && (m.spatialReference = new qe({ wkid: t })));
  const c = ce(E(n, "adresseId"));
  if (c !== void 0 && !Number.isFinite(c))
    return;
  const p = Number(E(n, "OBJECTID"));
  return {
    teigId: s,
    matrikkelenhetId: d,
    omradeId: l,
    omradetype: u,
    operation: o,
    geometry: m,
    deltaObjectId: Number.isFinite(p) ? p : void 0,
    adresseId: c
  };
}
function Dt(e, r, t) {
  const n = e?.features ?? [], o = /* @__PURE__ */ new Map(), s = [], d = /* @__PURE__ */ new Map(), i = [];
  for (const l of n) {
    const a = vt(l, r, t);
    if (a)
      if (i.push(a), a.adresseId !== void 0) {
        const u = d.get(a.adresseId) ?? [];
        u.push(a), d.set(a.adresseId, u);
      } else if (a.matrikkelenhetId === void 0)
        s.push(a);
      else {
        const u = o.get(a.matrikkelenhetId) ?? [];
        u.push(a), o.set(a.matrikkelenhetId, u);
      }
  }
  for (const l of Xe(i))
    bt.warn(
      "Avvik-rader bryter invarianten (add+remove for samme relasjon) — skal ikke kunne skje med slett-motsatt-skrivingen; historiske rader?",
      l.map((a) => a.deltaObjectId)
    );
  return { perMatrikkelenhet: o, utenMatrikkelenhet: s, perAdresse: d };
}
const $ = (e) => e.replaceAll("'", "''"), Ot = (e) => e.endsWith("/") ? e.slice(0, -1) : e;
function Xt(e) {
  const r = Ot(e.eiendommerUrl), t = `${r}/query`, n = `${r}/applyEdits`, o = async (i, l, a) => {
    const u = e.ønsketWkid?.(), m = await A(t, {
      method: "post",
      signal: a?.signal,
      query: {
        f: "json",
        where: i,
        outFields: "OBJECTID,teigId,matrikkelenhetId,omradeid,omradetype,operation,adresseId",
        returnGeometry: !0,
        ...u != null ? { outSR: u } : {},
        orderByFields: "OBJECTID ASC"
      }
    });
    return Dt(m.data, l, u ?? void 0);
  }, s = (i) => {
    const l = i.omradeId === void 0 ? "omradeid IS NULL" : `omradeid = '${$(String(i.omradeId))}'`, a = i.omradetype ? `omradetype = '${$(String(i.omradetype))}'` : "(omradetype IS NULL OR omradetype = 'delomrade')", u = i.adresseId == null ? "adresseId IS NULL" : `adresseId = ${i.adresseId}`;
    return [
      `teigId = ${i.teigId}`,
      `matrikkelenhetId = ${i.matrikkelenhetId}`,
      l,
      a,
      u
    ].join(" AND ");
  }, d = async (i) => {
    i.length !== 0 && await A(n, {
      method: "post",
      query: { f: "json", deletes: i.join(",") }
    });
  };
  return {
    async hentDeltaerForOmråde(i, l, a) {
      const u = `omradeid = '${$(i)}' AND (omradetype = '${$(l)}' OR omradetype IS NULL)`;
      return o(u, { omradeId: i, omradetype: l }, a);
    },
    async hentDeltaerForOmråder(i, l, a) {
      if (i.length === 0)
        return { perMatrikkelenhet: /* @__PURE__ */ new Map(), utenMatrikkelenhet: [], perAdresse: /* @__PURE__ */ new Map() };
      const m = `omradeid IN (${i.map((c) => `'${$(c)}'`).join(",")}) AND (omradetype = '${$(l)}' OR omradetype IS NULL)`;
      return o(m, { omradetype: l }, a);
    },
    async settAvvik(i) {
      const l = await A(t, {
        method: "post",
        query: {
          f: "json",
          where: s(i),
          outFields: "OBJECTID,operation",
          returnGeometry: !1
        }
      }), a = [];
      for (const c of l.data.features ?? []) {
        const p = Number(E(c.attributes ?? {}, "OBJECTID")), f = E(c.attributes ?? {}, "operation");
        Number.isFinite(p) && (f === "add" || f === "remove") && a.push({ objectId: p, operation: f });
      }
      const u = a.filter((c) => c.operation === i.operation), m = a.filter((c) => c.operation !== i.operation);
      if (await d(m.map((c) => c.objectId)), u.length > 0) {
        await d(u.slice(1).map((c) => c.objectId));
        return;
      }
      m.length > 0 || await A(n, {
        method: "post",
        query: {
          f: "json",
          adds: JSON.stringify([
            {
              attributes: {
                teigId: i.teigId,
                matrikkelenhetId: i.matrikkelenhetId,
                omradeid: i.omradeId,
                omradetype: i.omradetype,
                operation: i.operation,
                // 13928: null for enhetsnivå — samme betydning som
                // historiske rader, som ikke har feltet satt.
                adresseId: i.adresseId ?? null
              },
              geometry: i.geometry.toJSON()
            }
          ])
        }
      });
    },
    async slettAlleForOmråde(i, l) {
      const a = `omradeid = '${$(i)}' AND (omradetype = '${$(l)}' OR omradetype IS NULL)`, m = (await A(t, {
        method: "post",
        query: { f: "json", where: a, returnIdsOnly: !0 }
      })).data.objectIds ?? [];
      await d(m);
    }
  };
}
const se = mr(null), Yt = ({
  client: e,
  children: r
}) => {
  const t = cr(
    () => ({
      client: e,
      queries: jt({
        seksjonRepo: e.seksjoner,
        områdeRepo: e.områder,
        elementRepo: e.elementer,
        delområdegruppeRepo: e.delområdegrupper
      })
    }),
    [e]
  );
  return /* @__PURE__ */ ur(se.Provider, { value: t, children: r });
};
function D() {
  const e = ke(se);
  if (!e)
    throw new Error(
      "useSeksjonClient må brukes innenfor en <SeksjonClientProvider>"
    );
  return e.client;
}
function xt() {
  return ke(se)?.client ?? null;
}
function B() {
  const e = ke(se);
  if (!e)
    throw new Error(
      "useSeksjonQueries må brukes innenfor en <SeksjonClientProvider>"
    );
  return e.queries;
}
function en(e, r = {}) {
  const t = B();
  return C(t.seksjoner.forContext(e, r));
}
function rn(e) {
  const r = B();
  return C(r.seksjoner.byGlobalId(e));
}
function tn(e) {
  const r = B();
  return C(r.områder.forPlan(e));
}
function nn(e, r) {
  const t = B();
  return C(t.områder.ancestry(e, r));
}
function on(e) {
  const r = B();
  return C(r.elementer.forSeksjon(e));
}
function sn(e) {
  const r = B();
  return C(r.delområdegrupper.forPlan(e));
}
const tr = (e, r) => {
  r ? e.invalidateQueries({
    queryKey: I.seksjoner.forContext(r)
  }) : e.invalidateQueries({ queryKey: I.seksjoner.all });
}, de = (e) => e.invalidateQueries({ queryKey: I.seksjoner.all });
function dn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.seksjoner.all,
    mutationFn: (t) => Jr({ seksjonRepo: e.seksjoner }, t),
    onSuccess: (t, n) => tr(r, n.context)
  });
}
function an() {
  const e = D(), r = b();
  return v({
    mutationKey: I.seksjoner.all,
    mutationFn: (t) => zr({ seksjonRepo: e.seksjoner }, t),
    // Bredt: delete kan endre arvelinjen (overrides peker til denne).
    onSuccess: () => de(r)
  });
}
function ln() {
  const e = D(), r = b();
  return v({
    mutationKey: I.seksjoner.all,
    mutationFn: (t) => Hr({ seksjonRepo: e.seksjoner, elementRepo: e.elementer }, t),
    // Override-toggle kan endre arvelinjen — invalider bredt.
    onSuccess: () => de(r)
  });
}
function un() {
  const e = D(), r = b();
  return v({
    mutationKey: I.seksjoner.all,
    mutationFn: (t) => rt({ seksjonRepo: e.seksjoner }, t),
    onSuccess: () => de(r)
  });
}
function mn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.seksjoner.all,
    mutationFn: (t) => tt({ seksjonRepo: e.seksjoner }, t),
    onSuccess: () => de(r)
  });
}
function cn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.seksjoner.all,
    mutationFn: (t) => nt({ seksjonRepo: e.seksjoner }, t),
    onMutate: async (t) => {
      const n = t.context ? I.seksjoner.forContext(t.context) : I.seksjoner.all;
      await r.cancelQueries({ queryKey: n });
      const o = r.getQueryData(n);
      return r.setQueryData(n, (s) => {
        if (!s)
          return s;
        const d = new Map(
          t.ordered.map((i) => [i.objectId, i.prioritet])
        );
        return s.map((i) => {
          const l = d.get(i.objectId);
          return l != null ? { ...i, prioritet: l } : i;
        });
      }), { previous: o };
    },
    onError: (t, n, o) => {
      const s = n.context ? I.seksjoner.forContext(n.context) : I.seksjoner.all;
      o?.previous !== void 0 && r.setQueryData(s, o.previous);
    },
    onSettled: (t, n, o) => tr(r, o.context)
  });
}
const ve = (e, r) => {
  e.invalidateQueries({ queryKey: I.områder.forPlan(r) }), e.invalidateQueries({ queryKey: I.områder.all });
};
function pn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.områder.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return dt({ områdeRepo: e.områder }, t);
    },
    onSuccess: (t, n) => ve(r, n.planId)
  });
}
function fn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.områder.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return at({ områdeRepo: e.områder }, t);
    },
    onSuccess: (t, n) => {
      n.planId ? ve(r, n.planId) : r.invalidateQueries({ queryKey: I.områder.all });
    }
  });
}
function yn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.områder.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return it(
        { områdeRepo: e.områder },
        { objectId: t.objectId, områdeId: t.områdeId }
      );
    },
    onSuccess: (t, n) => {
      n.planId ? ve(r, n.planId) : r.invalidateQueries({ queryKey: I.områder.all }), r.invalidateQueries({ queryKey: I.seksjoner.all });
    }
  });
}
const ae = (e, r) => e.invalidateQueries({
  queryKey: I.elementer.forSeksjon(r)
});
function In() {
  const e = D(), r = b();
  return v({
    mutationKey: I.elementer.all,
    mutationFn: (t) => {
      if (!e.elementer)
        throw new Error("elementer-repository ikke konfigurert");
      return ut({ elementRepo: e.elementer }, t);
    },
    onSuccess: (t, n) => ae(r, n.seksjonsGlobalId)
  });
}
function gn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.elementer.all,
    mutationFn: (t) => {
      if (!e.elementer)
        throw new Error("elementer-repository ikke konfigurert");
      return mt(
        { elementRepo: e.elementer },
        { objectId: t.objectId, tittel: t.tittel, beskrivelse: t.beskrivelse }
      );
    },
    onSuccess: (t, n) => {
      n.seksjonGlobalId ? ae(r, n.seksjonGlobalId) : r.invalidateQueries({ queryKey: I.elementer.all });
    }
  });
}
function hn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.elementer.all,
    mutationFn: (t) => {
      if (!e.elementer)
        throw new Error("elementer-repository ikke konfigurert");
      return ct(
        { elementRepo: e.elementer },
        { objectId: t.objectId }
      );
    },
    onSuccess: (t, n) => {
      n.seksjonGlobalId ? ae(r, n.seksjonGlobalId) : r.invalidateQueries({ queryKey: I.elementer.all });
    }
  });
}
function kn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.elementer.all,
    mutationFn: (t) => {
      if (!e.elementer)
        throw new Error("elementer-repository ikke konfigurert");
      return pt(
        { elementRepo: e.elementer },
        { ordered: t.ordered }
      );
    },
    onMutate: async (t) => {
      const n = I.elementer.forSeksjon(t.seksjonGlobalId);
      await r.cancelQueries({ queryKey: n });
      const o = r.getQueryData(n);
      return r.setQueryData(n, (s) => {
        if (!s)
          return s;
        const d = new Map(
          t.ordered.map((i) => [i.objectId, i.prioritet])
        );
        return s.map((i) => {
          const l = d.get(i.objectId);
          return l != null ? { ...i, prioritet: l } : i;
        });
      }), { previous: o };
    },
    onError: (t, n, o) => {
      const s = I.elementer.forSeksjon(n.seksjonGlobalId);
      o?.previous !== void 0 && r.setQueryData(s, o.previous);
    },
    onSettled: (t, n, o) => ae(r, o.seksjonGlobalId)
  });
}
const V = (e, r) => {
  e.invalidateQueries({
    queryKey: I.delområdegrupper.forPlan(r)
  }), e.invalidateQueries({ queryKey: I.områder.forPlan(r) });
};
function wn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.delområdegrupper.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return yt(
        {
          områdeRepo: e.områder,
          seksjonRepo: e.seksjoner
        },
        t
      );
    },
    onSuccess: (t, n) => V(r, n.planId)
  });
}
function jn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.delområdegrupper.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return It(
        { områdeRepo: e.områder },
        t
      );
    },
    onSuccess: (t, n) => V(r, n.planId)
  });
}
function bn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.delområdegrupper.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return gt(
        { områdeRepo: e.områder },
        t
      );
    },
    onSuccess: (t, n) => V(r, n.planId)
  });
}
function vn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.delområdegrupper.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return ht(
        { områdeRepo: e.områder },
        t
      );
    },
    onSuccess: (t, n) => V(r, n.planId)
  });
}
function Dn() {
  const e = D(), r = b();
  return v({
    mutationKey: I.delområdegrupper.all,
    mutationFn: (t) => {
      if (!e.områder)
        throw new Error("områder-repository ikke konfigurert");
      return kt(
        {
          områdeRepo: e.områder,
          seksjonRepo: e.seksjoner
        },
        t
      );
    },
    onSuccess: (t, n) => {
      V(r, n.planId), r.invalidateQueries({ queryKey: I.seksjoner.all });
    }
  });
}
class St {
  constructor(r = []) {
    this.rows = [], this.nextObjectId = 1e3, this.nextGuid = 1, this.rows.push(...r);
  }
  all() {
    return [...this.rows];
  }
  async fetch(r, t) {
    return this.rows.filter((n) => ge(r, n));
  }
  async fetchByGlobalId(r) {
    return this.rows.find((t) => t.globalId === r) ?? null;
  }
  async add(r) {
    const t = this.nextObjectId++, n = `gid-${this.nextGuid++}`, o = {
      ...r,
      objectId: t,
      globalId: n
    };
    return this.rows.push(o), o;
  }
  async update(r) {
    const t = this.rows.findIndex((n) => n.globalId === r.globalId);
    if (t === -1)
      throw new Error(`FakeSeksjonRepository: ${r.globalId} not found`);
    return this.rows[t] = { ...r }, this.rows[t];
  }
  async delete(r) {
    const t = this.rows.findIndex((n) => n.objectId === r);
    t !== -1 && this.rows.splice(t, 1);
  }
  async reorder(r) {
    for (const t of r) {
      const n = this.rows.find((o) => o.objectId === t.objectId);
      n && (n.prioritet = t.prioritet);
    }
  }
}
function ge(e, r) {
  const t = e.trim();
  return !t || t === "1=1" ? !0 : t.includes(" OR ") ? Ae(t, " OR ").some(
    (n) => ge(Ne(n), r)
  ) : t.includes(" AND ") ? Ae(t, " AND ").every(
    (n) => ge(Ne(n), r)
  ) : Ft(t, r);
}
function Ae(e, r) {
  const t = [];
  let n = 0, o = "";
  for (let s = 0; s < e.length; s++) {
    if (e[s] === "(" ? n++ : e[s] === ")" && n--, n === 0 && e.slice(s, s + r.length) === r) {
      t.push(o), o = "", s += r.length - 1;
      continue;
    }
    o += e[s];
  }
  return o && t.push(o), t.map((s) => s.trim());
}
function Ne(e) {
  const r = e.trim();
  return r.startsWith("(") && r.endsWith(")") ? r.slice(1, -1).trim() : r;
}
const pe = {
  GlobalID: "globalId",
  ObjectId: "objectId",
  PlanId: "planId",
  OmrådeId: "områdeId",
  Id: "id",
  ParentId: "parentId",
  ParentGlobalID: "parentGlobalId",
  Seksjonstype: "seksjonstype",
  Tittel: "tittel",
  Delområdetype: "delområdetype",
  Overstyrer: "overstyrer",
  Synlig: "synlig",
  Kommunal: "kommunal",
  Prioritet: "prioritet"
}, fe = /[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ0-9_]*/.source;
function Ft(e, r) {
  const t = e.match(new RegExp(`^(${fe})\\s+IN\\s+\\((.+)\\)$`, "i"));
  if (t) {
    const s = pe[t[1]];
    if (!s)
      return !0;
    const d = t[2].split(",").map((l) => l.trim().replace(/^'(.*)'$/, "$1")), i = r[s];
    return d.some(
      (l) => String(i) === l || Number(i) === Number(l)
    );
  }
  const n = e.match(new RegExp(`^(${fe})\\s+IS\\s+(NOT\\s+)?NULL$`, "i"));
  if (n) {
    const s = pe[n[1]];
    if (!s)
      return !0;
    const d = r[s], i = d != null && d !== "";
    return n[2] ? i : !i;
  }
  const o = e.match(new RegExp(`^(${fe})\\s*=\\s*(.+)$`));
  if (o) {
    const s = pe[o[1]];
    if (!s)
      return !0;
    const d = o[2].trim(), i = d.replace(/^'(.*)'$/, "$1"), l = r[s];
    return /^[01]$/.test(d) ? !!l == (d === "1") : String(l ?? "") === i;
  }
  return !0;
}
class On {
  constructor(r = []) {
    this.rows = [], this.overridesByTeig = /* @__PURE__ */ new Map(), this.overridesByGeometry = [], this.rows.push(...r);
  }
  /** Test-utility: seed per-teig overstyringer for findOverridesForTeig. */
  seedOverridesForTeig(r, t) {
    this.overridesByTeig.set(r, [...t]);
  }
  /**
   * Test-utility: seed treff for findOverridesByGeometry. Faken bryr seg
   * ikke om input-geometri — testen injiserer alle deltaer (add/remove,
   * delomrade/egendefinert) som geometrien skal returnere.
   */
  seedOverridesByGeometry(r) {
    this.overridesByGeometry = [...r];
  }
  async fetchEgendefinerteForPlan(r) {
    return this.rows.filter((t) => t.planId === r);
  }
  async resolveAncestry(r, t) {
    return {
      planId: t,
      delområdetyper: [],
      delområdeIds: [],
      ancestorOmrådeIds: [],
      gruppeIds: []
    };
  }
  async findOverridesForTeig(r, t) {
    return this.overridesByTeig.get(r) ?? [];
  }
  async findOverridesByGeometry(r) {
    return this.overridesByGeometry;
  }
  async fetchOmrådeByIds(r) {
    const t = new Set(r.map((n) => String(n)));
    return this.rows.filter((n) => t.has(n.id));
  }
  async findEgendefinerteByGeometry(r) {
    const n = (await this.findOverridesByGeometry(r)).filter((o) => o.omradetype === "egendefinert" && o.operation === "add").map((o) => o.omradeId);
    return this.fetchOmrådeByIds(n);
  }
  async add(r) {
    const t = {
      id: `${this.rows.length + 1}`,
      objectId: this.rows.length + 1,
      kind: r.kind ?? "egendefinert",
      navn: r.navn,
      planId: r.planId,
      parentType: r.parentType,
      parentId: r.parentId,
      code: r.code
    };
    return this.rows.push(t), t;
  }
  async update(r) {
    const t = this.rows.find((n) => n.objectId === r.objectId);
    if (!t)
      throw new Error(`FakeOmrådeRepository: objectId=${r.objectId} not found`);
    return Object.assign(t, r), t;
  }
  async delete(r) {
    const t = this.rows.findIndex((n) => n.objectId === r);
    t !== -1 && this.rows.splice(t, 1);
  }
}
class Sn {
  constructor(r = []) {
    this.rows = [], this.nextObjectId = 1, this.rows.push(...r);
  }
  async fetchForSection(r) {
    return this.rows.filter((t) => t.seksjonsGlobalId === r);
  }
  async add(r) {
    const t = {
      objectId: this.nextObjectId++,
      ...r
    };
    return this.rows.push(t), t;
  }
  async update(r, t) {
    const n = this.rows.find((o) => o.objectId === r);
    n && Object.assign(n, t);
  }
  async delete(r) {
    const t = this.rows.findIndex((n) => n.objectId === r);
    t !== -1 && this.rows.splice(t, 1);
  }
  async reorder(r) {
    for (const t of r) {
      const n = this.rows.find((o) => o.objectId === t.objectId);
      n && (n.prioritet = t.prioritet);
    }
  }
}
class Fn {
  constructor(r = []) {
    this.grupper = [], this.nextObjectId = 1, this.grupper.push(...r);
  }
  async fetchForPlan(r) {
    return this.grupper.filter((t) => t.planId === r);
  }
  async create(r) {
    const t = {
      id: `${this.nextObjectId}`,
      objectId: this.nextObjectId++,
      planId: r.planId,
      delområdetype: r.delområdetype,
      navn: r.navn,
      medlemmer: r.medlemmer ?? []
    };
    return this.grupper.push(t), t;
  }
  async addMembers({
    gruppeId: r,
    medlemmer: t
  }) {
    const n = this.grupper.find((o) => o.id === r);
    n && (n.medlemmer = Array.from(/* @__PURE__ */ new Set([...n.medlemmer, ...t])));
  }
  async removeMembers({
    gruppeId: r,
    medlemmer: t
  }) {
    const n = this.grupper.find((o) => o.id === r);
    if (n) {
      const o = new Set(t);
      n.medlemmer = n.medlemmer.filter((s) => !o.has(s));
    }
  }
  async rename({
    gruppeObjectId: r,
    navn: t
  }) {
    const n = this.grupper.find((o) => o.objectId === r);
    n && (n.navn = t);
  }
  async delete({
    gruppeObjectId: r
  }) {
    const t = this.grupper.findIndex((n) => n.objectId === r);
    t !== -1 && this.grupper.splice(t, 1);
  }
}
class Rt extends St {
  async fetch(r) {
    return this.all().filter((t) => he(r, t));
  }
}
const L = {
  GlobalID: "globalId",
  ObjectId: "objectId",
  PlanId: "planId",
  OmrådeId: "områdeId",
  Id: "id",
  ParentId: "parentId",
  ParentGlobalID: "parentGlobalId",
  Seksjonstype: "seksjonstype",
  Tittel: "tittel",
  Delområdetype: "delområdetype",
  Overstyrer: "overstyrer",
  Synlig: "synlig",
  Kommunal: "kommunal",
  Prioritet: "prioritet"
}, ee = /[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ0-9_]*/.source;
function he(e, r) {
  const t = Et(e.trim());
  if (!t || t === "1=1")
    return !0;
  const n = $e(t, " OR ");
  if (n.length > 1)
    return n.some((s) => he(s, r));
  const o = $e(t, " AND ");
  return o.length > 1 ? o.every((s) => he(s, r)) : At(t, r);
}
function Et(e) {
  let r = e.trim();
  for (; r.startsWith("(") && r.endsWith(")"); ) {
    let t = 0, n = !0;
    for (let o = 0; o < r.length; o++)
      if (r[o] === "(")
        t++;
      else if (r[o] === ")" && (t--, t === 0 && o < r.length - 1)) {
        n = !1;
        break;
      }
    if (!n)
      break;
    r = r.slice(1, -1).trim();
  }
  return r;
}
function $e(e, r) {
  const t = [];
  let n = 0, o = "";
  for (let s = 0; s < e.length; s++) {
    if (e[s] === "(" ? n++ : e[s] === ")" && n--, n === 0 && e.slice(s, s + r.length) === r) {
      t.push(o), o = "", s += r.length - 1;
      continue;
    }
    o += e[s];
  }
  return o && t.push(o), t.map((s) => s.trim());
}
function At(e, r) {
  const t = (i) => r[L[i]], n = e.match(new RegExp(`^(${ee})\\s+IN\\s+\\((.+)\\)$`, "i"));
  if (n) {
    if (!L[n[1]])
      return !0;
    const i = n[2].split(",").map((a) => a.trim().replace(/^'(.*)'$/, "$1")), l = t(n[1]);
    return i.some((a) => String(l) === a || Number(l) === Number(a));
  }
  const o = e.match(new RegExp(`^(${ee})\\s+IS\\s+(NOT\\s+)?NULL$`, "i"));
  if (o) {
    if (!L[o[1]])
      return !0;
    const i = t(o[1]), l = i != null && i !== "";
    return o[2] ? l : !l;
  }
  const s = e.match(new RegExp(`^(${ee})\\s+LIKE\\s+'(.*)'$`, "i"));
  if (s) {
    if (!L[s[1]])
      return !0;
    const i = t(s[1]);
    if (i == null)
      return !1;
    const l = s[2].replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/%/g, ".*").replace(/_/g, ".");
    return new RegExp(`^${l}$`).test(String(i));
  }
  const d = e.match(new RegExp(`^(${ee})\\s*=\\s*(.+)$`));
  if (d) {
    if (!L[d[1]])
      return !0;
    const i = d[2].trim(), l = i.replace(/^'(.*)'$/, "$1"), a = t(d[1]);
    return /^[01]$/.test(i) ? !!a == (i === "1") : String(a ?? "") === l;
  }
  return !0;
}
const Nt = {
  Reguleringsplan: 0,
  Bebyggelsesplan: 0,
  Kommunedelplan: 1,
  Kommuneplan: 2
};
function Pe(e, r) {
  return ze(e, Array.from(r));
}
function $t(e, r) {
  const t = new Set(e.map((o) => o.id)), n = /* @__PURE__ */ new Set();
  for (const o of r)
    o.operation !== "add" || o.omradetype !== "delomrade" || t.has(o.omradeId) || n.add(o.omradeId);
  return Array.from(n);
}
class Q {
  constructor(r, t) {
    this.rot = r, this.scope = t;
  }
  /** Vanlig veiledningspunkt registrert på dette nivået. */
  veiledning(r, t = {}) {
    return this.rot._leggTilSeksjon(r, this.scope, t), this;
  }
  /**
   * Tilpasning (override) av `parentId` på dette nivået — kopi av kilden med
   * `parentGlobalId` + `overstyrer=true`, slik `toggleSectionOverride`
   * oppretter den.
   */
  tilpasning(r, t = {}) {
    return this.rot._leggTilTilpasning(r, this.scope, t), this;
  }
  /**
   * Skjul `parentId` på dette nivået — hide-metadata-rad (`synlig=false`,
   * `overstyrer=false`, `parentGlobalId`), slik `hideInheritedSection`
   * oppretter den.
   */
  skjul(r, t = {}) {
    return this.rot._leggTilSkjul(r, this.scope, t), this;
  }
}
class Pt extends Q {
  constructor(r, t) {
    super(r, { seksjonstype: "Plan", planId: t }), this.planId = t;
  }
  delområdetype(r, t) {
    const n = new Q(this.rot, {
      seksjonstype: "Delområdetype",
      planId: this.planId,
      delområdetype: r
    });
    return t?.(n), this;
  }
  delområde(r, t = {}, n) {
    this.rot._registrerDelområde(this.planId, r, t);
    const o = new Q(this.rot, {
      seksjonstype: "Delområde",
      planId: this.planId,
      områdeId: r,
      delområdetype: t.type
    });
    return n?.(o), this;
  }
  gruppe(r, t = {}, n) {
    this.rot._registrerGruppe(this.planId, r, t);
    const o = new Q(this.rot, {
      seksjonstype: "Delområdegruppe",
      planId: this.planId,
      områdeId: r,
      delområdetype: t.type
    });
    return n?.(o), this;
  }
  egendefinert(r, t = {}, n) {
    this.rot._registrerEgendefinert(this.planId, r, t);
    const o = new Q(this.rot, {
      seksjonstype: "Område",
      planId: this.planId,
      områdeId: r
    });
    return n?.(o), this;
  }
}
class Tt {
  constructor() {
    this.seksjonRader = [], this.områdeRader = [], this.delområder = /* @__PURE__ */ new Map(), this.egendefinerte = /* @__PURE__ */ new Map(), this.planer = /* @__PURE__ */ new Map(), this.avvikRader = [], this.objectIdTeller = 1, this.prioritetTeller = 0;
  }
  // ------------------------------------------------------------------
  // Deklarasjon
  // ------------------------------------------------------------------
  /** Kommunal standard-seksjon (gjelder i alle kontekster). */
  kommunalStandard(r, t = {}) {
    return this._leggTilSeksjon(r, { seksjonstype: "Kommune" }, { kommunal: !0, ...t }), this;
  }
  /**
   * Skjul `parentId` på Kommune-nivå — hide-metadata-rad med
   * `seksjonstype='Kommune'` og `kommunal=true`. Siden WHERE-byggeren alltid
   * inkluderer `(Seksjonstype='Kommune' OR Kommunal=1)` vil raden treffes i
   * ALLE kontekster i kommunen, og enrichment-passet markerer kilden som
   * skjult overalt (SKJ-11).
   *
   * Kan bare brukes på seksjoner uten planId/omradeId — speiler at
   * hideInheritedSection kaller contextFields({ type: 'Kommune' }).
   */
  skjulPåKommune(r, t = {}) {
    return this._leggTilSkjul(r, { seksjonstype: "Kommune" }, t), this;
  }
  plan(r, t, n) {
    this.kravIkkeBygget();
    const o = typeof t == "function" ? {} : t ?? {}, s = typeof t == "function" ? t : n, d = o.rang ?? Nt[(o.planType ?? "Reguleringsplan").replace(/_VN\d+$/, "")] ?? Number.MAX_SAFE_INTEGER;
    return this.planer.set(r, { rang: d }), s?.(new Pt(this, r)), this;
  }
  /**
   * Eiendoms-avvik («delta»-rad i eiendommer-laget). `matrikkelenhetId`
   * utelatt = geometri-/teig-bredt avvik som gjelder alle enheter på teigen.
   */
  avvik(r) {
    return this.kravIkkeBygget(), this.avvikRader.push(r), this;
  }
  // ------------------------------------------------------------------
  // Oppslag / interop
  // ------------------------------------------------------------------
  /**
   * Det delte in-memory-repoet — for tester som vil kjøre virkelige
   * use-cases (f.eks. `hideInheritedSection`/`unhideInheritedSection`)
   * mellom resolve-kall. Etter første tilgang kan scenariet ikke lenger
   * deklarere nye data.
   */
  get seksjonRepo() {
    return this.repo || (this.repo = new Rt(this.seksjonRader)), this.repo;
  }
  /** Slå opp en deklarert seksjon (f.eks. for objectId til use-cases). */
  seksjon(r) {
    const t = this.seksjonRepo.all().find((n) => n.globalId === r);
    if (!t)
      throw new Error(`Scenario: ukjent seksjon '${r}'`);
    return t;
  }
  // ------------------------------------------------------------------
  // Oppløsning
  // ------------------------------------------------------------------
  /**
   * Én-konteksts-oppløsning — speiler citizen sin per-kontekst-query i
   * `useSeksjonData.buildPlanQueries`: ancestry via de virkelige
   * resolve-funksjonene, kandidater fra registreringen, og selve lastingen
   * via `loadSectionsForContext` (ekte WHERE + filter + enrichment).
   */
  async resolveFor(r, t = {}) {
    const n = new Set(t.removedGruppeIds ?? []), o = { seksjonRepo: this.seksjonRepo };
    if (r.type === "Delområde") {
      const s = this.delområder.get(r.områdeId), d = t.delområdetypeCandidates ?? s?.typeCandidates ?? [], i = t.områdeIdCandidates ?? s?.idCandidates, l = {
        ...r,
        // Som i buildPlanQueries: første arealformål-kandidat blir
        // kontekstens delområdetype.
        delområdetype: r.delområdetype ?? d[0]
      }, a = Pe(
        be(
          r.områdeId,
          r.planId,
          this.områderForPlan(r.planId),
          []
        ),
        n
      );
      return re(o, {
        context: l,
        ancestry: a,
        områdeIdCandidates: i,
        delområdetypeCandidates: d
      });
    }
    if (r.type === "Område") {
      const s = Pe(
        H(
          r.områdeId,
          r.planId,
          this.områderForPlan(r.planId),
          []
        ),
        n
      );
      return re(o, { context: r, ancestry: s });
    }
    return re(o, {
      context: r,
      områdeIdCandidates: t.områdeIdCandidates,
      delområdetypeCandidates: t.delområdetypeCandidates
    });
  }
  /**
   * Eiendoms-oppløsning — speiler komposisjonen i `usePlanData` +
   * `useSeksjonData`:
   *
   *   1. `scopeOverridesToMatrikkelenhet` forfiner avvik til søkt enhet.
   *   2. Avvik splittes: egendefinert-add = primær utstrekning; plan-remove
   *      ekskluderer hele planen; resten anvendes per område.
   *   3. `applyPropertyOverrides` per plan for delområder (med addables for
   *      add av delområder teigen ikke treffer geometrisk) og egendefinerte.
   *   4. Kontekst-fanout per effektivt område (delområder først, deretter
   *      egendefinerte shallow-first), Plan-fallback når planen er tom.
   *   5. `mergeUniqueByGlobalId` med plan-type-rang.
   *
   * Returnerer den flate, dedupliserte innbyggerlisten. Hvis alle planer
   * fjernes av plan-nivå-avvik returneres tom liste (appen viser feilmelding
   * i samme situasjon).
   */
  async resolveForEiendom({
    treffer: r,
    matrikkelenhetId: t,
    adresseId: n
  }) {
    const o = Ve(
      this.avvikRader,
      t,
      n
    ), s = o.filter((y) => y.omradetype === "egendefinert" && y.operation === "add").map((y) => y.omradeId), d = o.filter(
      (y) => y.omradetype !== "plan" && !(y.omradetype === "egendefinert" && y.operation === "add")
    ), i = [], l = (y) => {
      i.includes(y) || i.push(y);
    }, a = [], u = [];
    for (const y of r)
      if ("plan" in y)
        l(y.plan);
      else if ("delområde" in y) {
        const O = this.delområder.get(y.delområde);
        if (!O)
          throw new Error(`Scenario: ukjent delområde '${y.delområde}'`);
        a.push(O), l(O.planId);
      } else {
        const O = this.egendefinerte.get(y.egendefinert);
        if (!O)
          throw new Error(`Scenario: ukjent egendefinert '${y.egendefinert}'`);
        u.push(O.id), l(O.planId);
      }
    for (const y of s)
      this.egendefinerte.get(y) && !u.includes(y) && u.push(y);
    const m = u.map((y) => this.egendefinerte.get(y)).filter((y) => !!y), c = new Set(
      o.filter((y) => y.omradetype === "plan" && y.operation === "remove").map((y) => y.omradeId)
    ), p = i.filter((y) => !c.has(y)), f = this.planTypeRank();
    p.sort((y, O) => f(y) - f(O));
    const g = d.filter((y) => y.omradetype === "delomradegruppe" && y.operation === "remove").map((y) => y.omradeId), F = [];
    for (const y of p) {
      const O = a.filter((w) => w.planId === y), N = $t(O, d).map((w) => this.delområder.get(w)).filter((w) => !!w && w.planId === y), Z = Ie(O, d, {
        getKey: (w) => ({ omradeId: w.id, omradetype: "delomrade" }),
        addables: N
      }), nr = m.filter(
        (w) => !w.planId || w.planId === y
      ), or = Ie(
        nr,
        d,
        { getKey: (w) => ({ omradeId: w.id, omradetype: "egendefinert" }) }
      ), M = [];
      for (const w of Z)
        M.push(
          this.resolveFor(
            { type: "Delområde", planId: y, områdeId: w.id },
            { removedGruppeIds: g }
          )
        );
      const De = or.map((w) => ({
        område: w,
        dybde: H(w.id, y, this.områderForPlan(y), []).ancestorOmrådeIds.length
      }));
      De.sort((w, sr) => w.dybde - sr.dybde);
      for (const { område: w } of De)
        M.push(
          this.resolveFor(
            { type: "Område", planId: y, områdeId: w.id },
            { removedGruppeIds: g }
          )
        );
      M.length === 0 && M.push(this.resolveFor({ type: "Plan", planId: y })), F.push(...await Promise.all(M));
    }
    return He(F, f);
  }
  // ------------------------------------------------------------------
  // Interne byggere (kalles fra nivå-klassene)
  // ------------------------------------------------------------------
  /** @internal */
  _leggTilSeksjon(r, t, n) {
    this.kravIkkeBygget(), this.kravUnik(r), this.seksjonRader.push({
      globalId: r,
      objectId: this.objectIdTeller++,
      seksjonstype: t.seksjonstype,
      planId: t.planId,
      områdeId: t.områdeId,
      delområdetype: t.delområdetype,
      tittel: n.tittel ?? r,
      tekst: n.tekst ?? "",
      synlig: n.synlig ?? !0,
      kommunal: n.kommunal ?? t.seksjonstype === "Kommune",
      infoboks: n.infoboks ?? !1,
      topp: n.topp,
      prioritet: n.prioritet ?? this.prioritetTeller++,
      overstyrer: !1
    });
  }
  /** @internal — speiler raden `toggleSectionOverride` oppretter. */
  _leggTilTilpasning(r, t, n) {
    this.kravIkkeBygget();
    const o = this.seksjonRader.find((i) => i.globalId === r);
    if (!o)
      throw new Error(
        `Scenario: tilpasning av ukjent seksjon '${r}' — deklarer kilden først`
      );
    const s = n.id ?? `tilpasset-${r}-${this.nivåId(t)}`;
    this.kravUnik(s);
    const d = t.seksjonstype === "Delområdetype" || t.seksjonstype === "Delområdegruppe" || t.seksjonstype === "Delområde";
    this.seksjonRader.push({
      ...o,
      globalId: s,
      objectId: this.objectIdTeller++,
      seksjonstype: t.seksjonstype,
      planId: t.planId ?? o.planId,
      områdeId: t.områdeId,
      delområdetype: d ? t.delområdetype : o.delområdetype,
      parentGlobalId: r,
      parentId: o.id,
      overstyrer: !n.deaktivert,
      synlig: n.synlig ?? !0,
      tittel: n.tittel ?? o.tittel,
      tekst: n.tekst ?? o.tekst,
      topp: n.topp ?? o.topp,
      prioritet: n.prioritet ?? o.prioritet
    });
  }
  /** @internal — speiler raden `hideInheritedSection` oppretter. */
  _leggTilSkjul(r, t, n) {
    this.kravIkkeBygget();
    const o = this.seksjonRader.find((d) => d.globalId === r);
    if (!o)
      throw new Error(
        `Scenario: skjuling av ukjent seksjon '${r}' — deklarer kilden først`
      );
    const s = n.id ?? `skjul-${r}-${this.nivåId(t)}`;
    this.kravUnik(s), this.seksjonRader.push({
      globalId: s,
      objectId: this.objectIdTeller++,
      seksjonstype: t.seksjonstype,
      planId: t.planId,
      områdeId: t.områdeId,
      delområdetype: t.delområdetype,
      tittel: o.tittel,
      tekst: "",
      synlig: !1,
      kommunal: t.seksjonstype === "Kommune",
      infoboks: !1,
      topp: !1,
      prioritet: 0,
      overstyrer: !1,
      parentGlobalId: r,
      parentId: o.id
    });
  }
  /** @internal */
  _registrerDelområde(r, t, n) {
    this.kravIkkeBygget(), this.delområder.set(t, {
      id: t,
      planId: r,
      typeCandidates: n.typeCandidates ?? (n.type ? [n.type] : []),
      idCandidates: n.idCandidates ?? [t]
    }), n.gruppe && this.leggTilMedlemsrad(r, n.gruppe, t);
  }
  /** @internal */
  _registrerGruppe(r, t, n) {
    this.kravIkkeBygget(), this.områdeRader.push({
      id: t,
      objectId: this.objectIdTeller++,
      kind: "delomradegruppe",
      navn: n.navn ?? t,
      planId: r,
      parentType: "Delområdetype",
      parentId: n.type ?? ""
    });
    for (const o of n.medlemmer ?? [])
      this.leggTilMedlemsrad(r, t, o);
  }
  /** @internal */
  _registrerEgendefinert(r, t, n) {
    this.kravIkkeBygget();
    let o, s;
    n.parent ? (o = "Område", s = n.parent) : n.parentDelområde ? (o = "Delområde", s = n.parentDelområde) : n.parentDelområdetype && (o = "Delområdetype", s = n.parentDelområdetype);
    const d = {
      id: t,
      objectId: this.objectIdTeller++,
      kind: "egendefinert",
      navn: n.navn ?? t,
      planId: r,
      parentType: o,
      parentId: s
    };
    this.områdeRader.push(d), this.egendefinerte.set(t, d);
  }
  // ------------------------------------------------------------------
  // Hjelpere
  // ------------------------------------------------------------------
  leggTilMedlemsrad(r, t, n) {
    this.områdeRader.push({
      id: `medlem-${t}-${n}`,
      objectId: this.objectIdTeller++,
      kind: "delomradegruppe-member",
      navn: n,
      planId: r,
      parentType: "Område",
      parentId: t,
      code: n
    });
  }
  /** Speiler `fetchEgendefinerteForPlan` — hele områdepoolen for planen. */
  områderForPlan(r) {
    return this.områdeRader.filter((t) => t.planId === r);
  }
  planTypeRank() {
    return (r) => r ? this.planer.get(r)?.rang ?? Number.MAX_SAFE_INTEGER : Number.MAX_SAFE_INTEGER;
  }
  nivåId(r) {
    return r.områdeId ?? r.delområdetype ?? r.planId ?? "kommune";
  }
  kravUnik(r) {
    if (this.seksjonRader.some((t) => t.globalId === r))
      throw new Error(`Scenario: duplisert globalId '${r}'`);
  }
  kravIkkeBygget() {
    if (this.repo)
      throw new Error(
        "Scenario: repoet er allerede bygget (etter første resolve/seksjonRepo-tilgang) — deklarer alle data først"
      );
  }
}
function Rn() {
  return new Tt();
}
export {
  T as AbortedError,
  yr as AuthError,
  K as ConfigurationError,
  Fn as FakeDelområdegruppeRepository,
  On as FakeOmrådeRepository,
  St as FakeSeksjonRepository,
  Sn as FakeSeksjonelementRepository,
  k as NetworkError,
  fr as OmrådeCycleError,
  Ce as OmrådeNotFoundError,
  pr as OverrideConflictError,
  Tt as Scenario,
  Rt as ScenarioSeksjonRepository,
  Yt as SeksjonClientProvider,
  R as SeksjonError,
  oe as SeksjonNotFoundError,
  jr as SeksjonsTypeValues,
  kr as TOMT_DELTASETT,
  G as ValidationError,
  It as addMembersToDelområdegruppe,
  ut as addSectionElement,
  wr as anvendDeltaerPåEnhetstre,
  Ze as anvendTeigDeltaer,
  Ie as applyPropertyOverrides,
  _ as buildInClause,
  Ur as buildSectionWhere,
  gr as canEdit,
  Me as canHide,
  Be as canToggleOverride,
  _e as compareSeksjonOrder,
  Xt as createArcgisAvvikRepository,
  _r as createArcgisDelområdegruppeRepository,
  Kr as createArcgisOmrådeRepository,
  Er as createArcgisSeksjonRepository,
  Mr as createArcgisSeksjonelementRepository,
  dt as createCustomOmråde,
  yt as createDelområdegruppe,
  Ht as createSeksjonClient,
  Se as ctxKey,
  kt as deleteDelområdegruppe,
  it as deleteOmråde,
  zr as deleteSection,
  ct as deleteSectionElement,
  Jt as domain,
  z as encodeOmrådeNavn,
  Le as enrichSections,
  $r as escapeSqlValue,
  zt as fetchByGlobalIdOrThrow,
  Xe as finnBruddrader,
  ye as getSectionPosition,
  rt as hideInheritedSection,
  Ir as isInherited,
  P as isKommunal,
  ft as loadDelområdegrupperForPlan,
  ot as loadOmråderForPlan,
  lt as loadSectionElements,
  re as loadSectionsForContext,
  He as mergeUniqueByGlobalId,
  X as områdeFromAttrs,
  Dt as parseDeltaFeatures,
  h as qv,
  gt as removeMembersFromDelområdegruppe,
  ht as renameDelområdegruppe,
  pt as reorderSectionElements,
  nt as reorderSections,
  be as resolveDelområdeAncestors,
  H as resolveOmrådeAncestors,
  st as resolveOmrådeAncestry,
  Zt as resolveOmrådeAncestryFrom,
  Dr as sanitizeArcgisHtml,
  Jr as saveSection,
  Rn as scenario,
  Ve as scopeOverridesToMatrikkelenhet,
  Vt as seksjonEditableSchema,
  le as seksjonFromAttrs,
  Wr as seksjonInputSchema,
  Ye as seksjonInputToAttrs,
  I as seksjonKeys,
  jt as seksjonQueries,
  Rr as seksjonToAttrs,
  Re as seksjonelementFromAttrs,
  Br as seksjonelementInputToAttrs,
  ze as stripRemovedGruppeIds,
  Hr as toggleSectionOverride,
  tt as unhideInheritedSection,
  at as updateOmråde,
  jn as useAddDelområdegruppeMedlemmer,
  In as useAddSeksjonelement,
  wn as useCreateDelområdegruppe,
  pn as useCreateOmråde,
  Dn as useDeleteDelområdegruppe,
  yn as useDeleteOmråde,
  an as useDeleteSeksjon,
  hn as useDeleteSeksjonelement,
  sn as useDelområdegrupper,
  un as useHideInheritedSeksjon,
  nn as useOmrådeAncestry,
  tn as useOmråder,
  bn as useRemoveDelområdegruppeMedlemmer,
  vn as useRenameDelområdegruppe,
  kn as useReorderSeksjonelementer,
  cn as useReorderSeksjoner,
  dn as useSaveSeksjon,
  rn as useSeksjon,
  D as useSeksjonClient,
  xt as useSeksjonClientOptional,
  on as useSeksjonelementer,
  en as useSeksjoner,
  ln as useToggleSeksjonOverride,
  mn as useUnhideInheritedSeksjon,
  fn as useUpdateOmråde,
  gn as useUpdateSeksjonelement
};
//# sourceMappingURL=index.mjs.map
